import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { LoginRequest, LoginResponse, LoginDataResponse, Condominium, LoginValidationResponse, ConfigurationResponse, AccountStatementConfigurationResponse, AccountStatementConfiguration, AccountStatementConfigurationRequest, ModulesByCondominiumResponse, ResetValidateResponse, ChangePasswordValidateResponse, ResetPasswordRequest, ChangePasswordRequest, ChangePasswordInAdminRequest, ChangePasswordInAdminValidateResponse, AllEmailResponse, EmailResponse, CreateEmailRequest, CreateUpdateEmailResponse, EmailValidateResponse, UpdateEmailRequest, AllConfigEmailResponse, ConfigEmailResponse, CreateConfigEmailRequest, CreateUpdateConfigEmailResponse, ConfigEmailValidateResponse, UpdateConfigEmailRequest, AllConfigPhoneResponse, ConfigPhoneResponse, CreateConfigPhoneRequest, CreateUpdateConfigPhoneResponse, ConfigPhoneValidateResponse, UpdateConfigPhoneRequest, AllConfigPaymentResponse, ConfigPaymentResponse, CreateUpdateConfigPaymentResponse, ConfigPaymentValidateResponse, UpdateConfigPaymentRequest, AllPhoneResponse, PhoneResponse, CreatePhoneRequest, CreateUpdatePhoneResponse, PhoneValidateResponse, UpdatePhoneRequest, AllDashboardChargesPaidResponse, DashboardChargesPaidResponse, AllDashboardHousesDebtResponse, DashboardHousesDebtResponse, AllDashboardHousesDebtCondominiumSonsResponse, DashboardHousesDebtCondominiumSonsResponse, AllDashboardBalanceReportResponse, ChargesPaidPDFRequest, HousesDebtPDFRequest, BalanceReportPDFRequest, AllDashboardBalanceResponse, AllNewsResponse, NewsResponse, CreateNewsRequest, CreateUpdateNewsResponse, NewsValidateResponse, UpdateNewsRequest, AllProjectResponse, ProjectResponse, CreateProjectRequest, CreateUpdateProjectResponse, ProjectValidateResponse, UpdateProjectRequest, AllEventsResponse, EventsResponse, CreateEventRequest, CreateUpdateEventResponse, EventValidateResponse, UpdateEventRequest, AllResidentResponse, ResidentResponse, ChangePasswordResidentRequest, ChangePhotoResidentRequest, CreateUpdateResidentResponse, ResidentValidateResponse, CreateResidentRequest, UpdateResidentRequest, EmailsUserResponse, EmailsUser, AllEmergencyResponse, EmergencyResponse, CreateUpdateEmergencyResponse, EmergencyValidateResponse, UpdateEmergencyRequest, AllIncidenceResponse, IncidenceResponse, CreateUpdateIncidenceResponse, IncidenceValidateResponse, UpdateIncidenceRequest, SearchIncidenceRequest, IncidenceRequest, AllIncidenceNoteResponse, IncidenceNoteResponse, CreateUpdateIncidenceNoteResponse, IncidenceNoteValidateResponse, CreateIncidenceNoteRequest, PayByConceptRequest, PayByConceptResponse, PaybyConceptValidateResponse, MultiplePayResponse, MultipleValidateResponse, CreateMultiplePayRequestRequest, ChargeMultiplePayRequestRequest, PaymentstoCancelResponse, PaymentToCancelResponse, ChargesByPaymentResponse, ChargesByPayment, AdvancedPaymentsResponse, AdvancedPayment, CancelPaymentsRequest, UpdatePaymentsRequest, AdvancedPaymentsRequest, CancelAndRcreateInvoiceRequest, AllChargeResponse, ChargesResponse, ChargeResponse, CreateUpdateStateChargeResponse, StateChargeValidateResponse, UpdateStateChargeRequest, UpdateChargeRequest, UpdateChargeValidateResponse, CreateChargesRequest, CreateHistoryChargesRequest, ChargeValidateResponse, AllChargeWithoutFormatResponse, ChargeWithoutFormatResponse, UpdateDescriptionChargeRequest, UpdateDescriptionChargeValidateResponse, PaymentsByChargeResponse, PaymentByCharge, PositiveBalanceInConceptsResponse, PositiveBalanceInConcepts, PaymentDefaultResponse, AllCatalogResponse, CatalogResponse, AllCatalogWithCantResponse, CatalogWithCantResponse, AllUsoCFDIResponse, usoCFDIResponse, AllUserAdminResponse, UserAdminResponse, CreateUpdateUserAdminResponse, UserAdminValidateResponse, CreateUserAdminRequest, UpdateUserAdminRequest, AllHouseResponse, HouseResponse, CreateUpdateHouseResponse, HouseValidateResponse, CreateHouseRequest, UpdateHouseRequest, AllHouseServiceResponse, HouseServiceResponse, UpdateHouseServiceRequest, HouseServiceRequest, HouseServiceValidateResponse, AllHouseAccountResponse, HouseAccountResponse, UpdateHouseAccountRequest, HouseAccountRequest, HouseAccountValidateResponse, AllListHouseResponse, ListHouseResponse, AllListHouse_HouseResponse, CreateUpdateListHouseResponse, ListHouseValidateResponse, CreateListHouseRequest, UpdateListHouseRequest, AllAccountResponse, AllAccountByChargeResponse, AccountByChargeResponse, CreateUpdateAccountResponse, AccountResponse, CreateAccountRequest, UpdateAccountRequest, AccountValidateResponse, AllConceptResponse, CreateUpdateConceptResponse, ConceptResponse, CreateConceptRequest, UpdateConceptRequest, ConceptValidateResponse, AllEstimateResponse, CreateUpdateEstimateResponse, EstimateResponse, AllEstimateConceptResponse, CreateEstimateRequest, UpdateEstimateRequest, EstimateConceptResponse, AllEstimateTaxResponse, EstimateTaxResponse, EstimateValidateResponse, EstimateConceptRequest, AllConceptCategoryResponse, CreateUpdateConceptCategoryResponse, ConceptCategoryResponse, CreateConceptCategoryRequest, UpdateConceptCategoryRequest, ConceptCategoryValidateResponse, AllProviderResponse, CreateUpdateProviderResponse, ProviderResponse, CreateProviderRequest, UpdateProviderRequest, ProviderValidateResponse, AllAreaIncidenceResponse, CreateUpdateAreaIncidenceResponse, AreaIncidenceResponse, CreateAreaIncidenceRequest, UpdateAreaIncidenceRequest, AreaIncidenceValidateResponse, AllTypeIncidenceResponse, CreateUpdateTypeIncidenceResponse, TypeIncidenceResponse, CreateTypeIncidenceRequest, UpdateTypeIncidenceRequest, TypeIncidenceValidateResponse, AllIncidenceResponsibleResponse, IncidenceResponsibleResponse, CreateIncidenceResponsibleRequest, UpdateIncidenceResponsibleRequest, IncidenceResponsibleValidateResponse, AllCarResponse, CreateUpdateCarResponse, CarResponse, CreateCarRequest, UpdateCarRequest, CarValidateResponse, AllCourseResponse, CreateUpdateCourseResponse, CourseResponse, CreateCourseRequest, UpdateCourseRequest, CourseValidateResponse, CourseDetailResponse, CourseDetailDataResponse, AllCourseInstructorResponse, CreateUpdateCourseInstructorResponse, CourseInstructorResponse, CreateCourseInstructorRequest, UpdateCourseInstructorRequest, CourseInstructorValidateResponse, AllCourseClassResponse, CreateUpdateCourseClassResponse, CourseClassResponse, CreateCourseClassRequest, UpdateCourseClassRequest, CourseClassValidateResponse, AllWorkerProjectResponse, WorkerProjectResponse, CreateWorkerProjectRequest, UpdateWorkerProjectRequest, CreateUpdateWorkerProjectResponse, AllWorkerUserResponse, WorkerUserResponse, OneWorkerUserResponse, CreateWorkerUserRequest, UpdateWorkerUserRequest, CreateWorkerUserProjectRequest, CreateUpdateWorkerUserResponse, AllWorkerProjectUserResponse, WorkerProjectUserResponse, CreateWorkerUserProjectAddRequest, SendEmailWorkerUserRequest, AllWorkerRegisterResponse, WorkerRegisterResponse, SearchWorkerRegisterRequest, AllWorkerRegisterMovementResponse, WorkerRegisterMovementResponse, AllWorkerUserByTypeResponse, WorkerUserByTypeResponse, AllFingerResponse, FingerResponse, CreateFingerRequest, AllCommonAreaRestrictedResponse, CreateUpdateCommonAreaRestrictedResponse, CommonAreaRestrictedResponse, CommonAreaRestrictedDetailResponse, CreateCommonAreaRestrictedRequest, UpdateCommonAreaRestrictedRequest, CommonAreaRestrictedValidateResponse, AllPetResponse, CreateUpdatePetResponse, PetDetailResponse, PetResponse, CreatePetRequest, UpdatePetRequest, PetValidateResponse, PetSearchRequest, AllPetSearchResponse, PetSearchResponse, AllRecurringChargesResponse, CreateUpdateRecurringChargesResponse, RecurringChargesResponse, CreateRecurringChargesRequest, UpdateRecurringChargesRequest, RecurringChargesValidateResponse, AllRecurringChargesDatesResponse, RecurringChargesDatesResponse, AllRecurringChargesHousesResponse, RecurringChargesHousesResponse, AddHouseRecurringChargesRequest, AllRolAppResponse, CreateUpdateRolAppResponse, RolAppResponse, CreateRolAppRequest, UpdateRolAppRequest, RolAppValidateResponse, CodeActionsResponse, AllDocumentCategoryResponse, CreateUpdateDocumentCategoryResponse, DocumentCategoryResponse, CreateDocumentCategoryRequest, UpdateDocumentCategoryRequest, DocumentCategoryValidateResponse, AllDocumentResponse, CreateUpdateDocumentResponse, DocumentResponse, CreateDocumentRequest, UpdateDocumentRequest, DocumentValidateResponse, CreateWorkerTypeProjectRequest, UpdateWorkerTypeProjectRequest, AllServiceResponse, CreateUpdateServiceResponse, ServiceResponse, CreateServiceRequest, UpdateServiceRequest, ServiceValidateResponse, AllServiceChargeResponse, CreateUpdateServiceChargeResponse, ServiceChargeResponse, CreateServiceChargeRequest, UpdateServiceChargeRequest, ServiceChargeValidateResponse, ApplyServiceChargeRequest, UpdateLaterSaveServiceChargeRequest, AllServiceChargeHouseResponse, ServiceChargeHouseResponse, CreateServiceChargeHouseRequest, CreateUpdateServiceChargeHouseResponse, ServiceChargeHouseValidateResponse, AllServiceTariffResponse, CreateUpdateServiceTariffResponse, ServiceTariffResponse, CreateServiceTariffRequest, UpdateServiceTariffRequest, ServiceTariffValidateResponse, AllPayoutsResponse, PayoutsResponse, AllPayoutsDetailsResponse, PayoutsDetailsResponse, RequestPayoutsRequest, AllTariffResponse, TariffResponse, AllTariffHousesResponse, TariffHousesResponse, UpdateTariffRequest, TariffValidateResponse, ExcelTariffRequest, AdjusterChargerRequest, AllAdjustmentResponse, AdjustmentResponse, AllAdjustmentChargesResponse, AdjustmentChargesResponse, AllServiceMeterResponse, CreateUpdateServiceMeterResponse, ServiceMeterResponse, CreateServiceMeterRequest, UpdateServiceMeterRequest, ServiceMeterValidateResponse, AllUnrecognizedPaymentResponse, CreateUpdateUnrecognizedPaymentResponse, UnrecognizedPaymentResponse, CreateUnrecognizedPaymentRequest, UpdateUnrecognizedPaymentRequest, UnrecognizedPaymentValidateResponse, AllAccountMovementResponse, AccountMovementResponse, CreateUpdateAccountMovementResponse, CreateAccountMovementRequest, AccountMovementValidateResponse, TransferResponse, CreateUpdateTransferResponse, CreateTransferRequest, TransferValidateResponse, AllExtraordinaryChargeResponse, OneExtraordinaryChargeResponse, CreateUpdateExtraordinaryChargeResponse, ExtraordinaryChargeResponse, ExtraordinaryChargeDetailResponse, CreateExtraordinaryChargeRequest, UpdateExtraordinaryChargeRequest, ExtraordinaryChargeValidateResponse, ExcelExtraordinaryChargeResponse, AllExtraordinaryChargeHouseResponse, ExtraordinaryChargeHouseResponse, UpdateExtraordinaryChargeDatesRequest, AllResidentHouseResponse, ResidentHouseStreetResponse, ResidentHouseResponse, CreateResidentHouseResponse, ResidentHouseValidateResponse, CreateResidentHouseRequest, CreateResidentHouseByHouseRequest, UpdateResidentHouseByHouseRequest, UpdateResidentHouseValidateResponse, AllHouseComboboxResponse, HouseComboboxResponse, AllResidentComboboxResponse, ResidentComboboxResponse, AllDirectoryResponse, DirectoryResponse, CreateDirectoryRequest, CreateUpdateDirectoryResponse, DirectoryValidateResponse, UpdateDirectoryRequest, AllCommonAreaResponse, CommonAreaResponse, CreateUpdateCommonAreaResponse, CommonAreaValidateResponse, CreateCommonAreaRequest, UpdateCommonAreaRequest, AllCommonAreaDaysMaintenanceResponse, CommonAreaDaysMaintenanceResponse, CreateCommonAreaDayMaintenanceRequest, AllCommonAreaBlockResponse, CommonAreaBlockResponse, AllCommonAreaHoursResponse, CommonAreaHourResponse, CreateCommonAreaHourResponse, CommonAreaHourValidateResponse, CreateCommonAreaHourRequest, AllCommonAreaHourAvailableResponse, AllReservationResponse, DisabledCalendarDaysResponse, ReservationAvailabilityResource, ReservationResponse, CreateUpdateReservationResponse, ReservationValidateResponse, CreateReservationResponse, CreateReservationRequest, ReservationBlockRequest, ExcelReservationResponse, AllRuleResponse, RuleResponse, CreateUpdateRuleResponse, RuleValidateResponse, CreateRuleRequest, UpdateRuleRequest, AllInvitationResponse, InvitationResponse, InvitationDetailResponse, InvitationDetail, UpdateInvitationRequest, CreateUpdateInvitationResponse, AllExpenseResponse, ExpenseResponse, CreateUpdateExpenseResponse, ExpenseValidateResponse, CreateExpenseRequest, UpdateExpenseRequest, ExpenseDetailResponse, ExpenseDetail, InvoicesResponse, InvoiceResponse, SendInvoiceRequest, SendInvoiceResponse, CancelInvoiceRequest, SendAccountStatementResponse, SendAccountStatementRequest, ReportPaymentsResponse, ReportPaymentResponse, ExcelReportPaymentResponse, ReportDebtorsResponse, ReportDebtorResponse, ExcelReportDebtorsResponse, ContpaqIncomePolicyResponse, ExcelCollectionTableResponse, ReportCollectionTableResponse, PDFAccountStatement, ReportExpensesResponse, ReportExpenseResponse, ExcelReportExpenseResponse, PDFReportInvoiceByDayResponse, CommonPDFReportResponse, PDFReportInvoiceByMonthResponse, ExcelReportInvoiceByMonthResponse, ExcelInvoiceResponse, ZipReportInvoiceByMonthResponse, ExcelBalanceReportResponse, SendAccountStatementValidationResponse, ExcelResponse, UrlResponse, CommonExcelReportResponse, ReportEstimateResponse, ReportEstimate, ExcelChargeHouseRequest, AllReportBankResponse, ReportBankResponse, AllReportChargeHouseResponse, ReportChargeHouse, AllReportIncomeResponse, ReportIncomeResponse, AccessCardResponse, AccessCard, CreateAccessCardRequest, UpdateAccessCardRequest, AccessCardDoorResponse, AccessCardDoor, CreateUpdateAccessCardResponse, AllEventReportResponse, EventReport, CreateEventReportRequest, SearchEventReportRequest, EventReportResponse, EventReportValidateResponse, FiscalDataResponse, FiscalData, CreateFiscalDataRequest, UpdateFiscalDataRequest, CreateUpdateFiscalDataResponse, CreateRechargeRequest, AllRechargesByChargeResponse, RechargesByCharge, ChargeRechargesResponse, ChargeRechargeResponse, UpdateRechargeResponse, UpdateRechargeRequest, UpdateRechargeValidateResponse, CreateRechargeValidateResponse, CreateRolDataRequest, UpdateRolDataRequest, AllRolResponse, RolResponse, AllRolInfoResponse, RolInfoResponse, AllModuleResponse, ModuleResponse, AllHousingResponse, HousingResponse, CreateHousingResponse, HousingRequest, UpdateHousingRequest, HousingGuest, CheckAvailableDateRequest, HousingDetailResponse, HousingDetail, HousingGuestDetail, CreateUpdateHousingResponse, CreateHousingValidateResponse, HousingCheckinRequest, EditHousingCheckinRequest, EditGuestsRequest, EditSubstitutesRequest, HousingCheckoutRequest, HousingCheckoutSelectableRequest, AllReportHousingResponse, EditDateHousingRequest, TransferHousingRequest, CreatePartialPaymentRequest, AllCondominiumFiscalDataResponse, CondominiumFiscalData, UpdateCondominiumFiscalDataRequest, FileStatusResponse, FileStatus, UploadFiscalFileRequest, UploadFiscalLogoRequest, AllCurrencyResponse, CurrencyReponse, CreateCurrencyRequest, CreateUpdateCurrencyResponse, UpdateCurrencyRequest, CurrencyValidateResponse, AllMapResponse, MapResponse, AllStringResponse, StringResponse, AllMapFlagResponse, MapFlagResponse, AllMapKeyResponse, MapKeyResponse, AllDebtHouseResponse, DebtHouseResponse, AllConceptWithCategoryResponse, ConceptWithCategoryResponse, AllUnrecognizedActivePaymentResponse, UnrecognizedActivePaymentResponse, NumberResponse, AllPanelGroupResponse, PanelGroupResponse, AllUnpaidChargesResponse, UnpaidChargesResponse, AllVisitorReportResponse, VisitorReportResponse, VisitorReportRequest, CreateVisitorReportValidateResponse, AllVisitorDetailResponse, VisitorDetailResponse, NoDataResponse, DataResponse, DataStringResponse, FileRequest, DataBooleanResponse, GenericResponse, ChargesImportExcelResponse, ChargesImportExcelValidateResponse, ChargesImportExcelRequest, InvitationUploadFilesResponse, InvitationUploadFiles, InvitationUploadFilesRequest, InvitationUpdateFilesRequest, InvitationUpdateFacePhotoRequest, InvitationCheckValidFaceRequest, InvitationCheckValidIdentificationRequest, CheckValidIdentificationResponse, EstimateExcel } from './models';

/**
* Created with angular4-swagger-client-generator.
*/
@Injectable()
export class ApiClientService {

  private domain = 'https://wsqa.frakcio.com/api/v1/admin';

  constructor(private http: HttpClient, @Optional() @Inject('domain') domain: string ) {
    if (domain) {
      this.domain = domain;
    }
  }

  /**
  * Method login
  * @param body The Datos de login
  * @return The full HTTP response as Observable
  */
  public login(body: LoginRequest): Observable<HttpResponse<LoginResponse>> {
    let uri = `/auth/login`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<LoginResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method resetPassword
  * @param body The Correo electrónico del usuario
  * @return The full HTTP response as Observable
  */
  public resetPassword(body: ResetPasswordRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/auth/reset`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<DataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method changePassword
  * @param body The Contraseña y confirmación de contraseña
  * @return The full HTTP response as Observable
  */
  public changePassword(body: ChangePasswordRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/auth/change`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<DataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method getConfiguration
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public getConfiguration(Authorization: string): Observable<HttpResponse<ConfigurationResponse>> {
    let uri = `/configuration/getconfiguration`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ConfigurationResponse>('get', uri, headers, params, null);
  }

  /**
  * Method getModulesByCondominium
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public getModulesByCondominium(Authorization: string, idCondominium: number): Observable<HttpResponse<ModulesByCondominiumResponse>> {
    let uri = `/configuration/${idCondominium}/getmodulesbycondominium`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ModulesByCondominiumResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateModuleInCondominium
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idModule The ID del módulo a modificar
  * @param newState The nuevo estado para modulo en condominio
  * @return The full HTTP response as Observable
  */
  public updateModuleInCondominium(Authorization: string, idCondominium: number, idModule: number, newState: boolean): Observable<HttpResponse<ModulesByCondominiumResponse>> {
    let uri = `/configuration/${idCondominium}/updatemoduleincondominium/${idModule}/${newState}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ModulesByCondominiumResponse>('put', uri, headers, params, null);
  }

  /**
  * Method getAccountStatementConfiguration
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public getAccountStatementConfiguration(Authorization: string, idCondominium: number): Observable<HttpResponse<AccountStatementConfigurationResponse>> {
    let uri = `/configuration/${idCondominium}/accountstatementconfiguration`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AccountStatementConfigurationResponse>('get', uri, headers, params, null);
  }

  /**
  * Method editAccountStatementConfiguration
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la configuración de estado de cuenta
  * @return The full HTTP response as Observable
  */
  public editAccountStatementConfiguration(Authorization: string, idCondominium: number, body: AccountStatementConfigurationRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/configuration/${idCondominium}/accountstatementconfiguration`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method mobileChangePassword
  * @param body The Contraseña y confirmación de contraseña
  * @return The full HTTP response as Observable
  */
  public mobileChangePassword(body: ChangePasswordRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/mobile/auth/change`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<DataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method ping
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public ping(Authorization: string): Observable<HttpResponse<DataResponse>> {
    let uri = `/ping`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('get', uri, headers, params, null);
  }

  /**
  * Method changepassworinadmin
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Contraseña y confirmación de contraseña
  * @return The full HTTP response as Observable
  */
  public changepassworinadmin(Authorization: string, idCondominium: number, body: ChangePasswordInAdminRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/profile/changepassword`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method resident
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa (opcional, 0 por defecto)
  * @return The full HTTP response as Observable
  */
  public resident(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllResidentResponse>> {
    let uri = `/condominium/${idCondominium}/house/${idHouse}/resident`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllResidentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createResident
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del residente a registrar
  * @return The full HTTP response as Observable
  */
  public createResident(Authorization: string, idCondominium: number, body: CreateResidentRequest): Observable<HttpResponse<CreateUpdateResidentResponse>> {
    let uri = `/condominium/${idCondominium}/resident`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateResidentResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateResident
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del residente a modificar
  * @return The full HTTP response as Observable
  */
  public updateResident(Authorization: string, idCondominium: number, body: UpdateResidentRequest): Observable<HttpResponse<CreateUpdateResidentResponse>> {
    let uri = `/condominium/${idCondominium}/resident`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateResidentResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteResident
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del residente
  * @param idResident The ID del residente
  * @return The full HTTP response as Observable
  */
  public deleteResident(Authorization: string, idCondominium: number, idResident: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/resident/${idResident}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method detailResident
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del residente
  * @param idResident The ID del residente
  * @return The full HTTP response as Observable
  */
  public detailResident(Authorization: string, idCondominium: number, idResident: number): Observable<HttpResponse<AllResidentResponse>> {
    let uri = `/condominium/${idCondominium}/resident/${idResident}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllResidentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method residentbyhouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public residentbyhouse(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllResidentResponse>> {
    let uri = `/condominium/${idCondominium}/residentbyhouse/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllResidentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method changepasswordresident
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la casa a registrar
  * @return The full HTTP response as Observable
  */
  public changepasswordresident(Authorization: string, idCondominium: number, body: ChangePasswordResidentRequest): Observable<HttpResponse<CreateUpdateResidentResponse>> {
    let uri = `/condominium/${idCondominium}/residentchangepassword`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateResidentResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method changephotoresident
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la casa a registrar
  * @return The full HTTP response as Observable
  */
  public changephotoresident(Authorization: string, idCondominium: number, body: ChangePhotoResidentRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/residentchangephoto`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method emailsuser
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idUser The Usuario para traer los correos
  * @return The full HTTP response as Observable
  */
  public emailsuser(Authorization: string, idCondominium: number, idUser: number): Observable<HttpResponse<EmailsUserResponse>> {
    let uri = `/condominium/${idCondominium}/resident/emails/${idUser}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<EmailsUserResponse>('get', uri, headers, params, null);
  }

  /**
  * Method qrstaticbyresident
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idResident The ID del residente
  * @return The full HTTP response as Observable
  */
  public qrstaticbyresident(Authorization: string, idCondominium: number, idResident: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/resident/qr/${idResident}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method zipqrstatic
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public zipqrstatic(Authorization: string, idCondominium: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/allresidentqr`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method dashboardChargesPaid
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idConcept The ID del concepto, 0 es mantenimiento
  * @param month1 The mes inicio
  * @param year1 The año inicio
  * @param month2 The mes fin
  * @param year2 The año fin
  * @return The full HTTP response as Observable
  */
  public dashboardChargesPaid(Authorization: string, idCondominium: number, idConcept: number, month1: number, year1: number, month2: number, year2: number): Observable<HttpResponse<AllDashboardChargesPaidResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/chargespaid/${idConcept}/${month1}/${year1}/${month2}/${year2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDashboardChargesPaidResponse>('get', uri, headers, params, null);
  }

  /**
  * Method dashboardChargesPaidPDF
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reporte a generar
  * @return The full HTTP response as Observable
  */
  public dashboardChargesPaidPDF(Authorization: string, idCondominium: number, body: ChargesPaidPDFRequest): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/chargespaidpdf`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method dashboardHousesDebt
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idConcept The ID del concepto, 0 es mantenimiento
  * @param month1 The mes inicio
  * @param year1 The año inicio
  * @param month2 The mes fin
  * @param year2 The año fin
  * @return The full HTTP response as Observable
  */
  public dashboardHousesDebt(Authorization: string, idCondominium: number, idConcept: number, month1: number, year1: number, month2: number, year2: number): Observable<HttpResponse<AllDashboardHousesDebtResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/housesdebt/${idConcept}/${month1}/${year1}/${month2}/${year2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDashboardHousesDebtResponse>('get', uri, headers, params, null);
  }

  /**
  * Method dashboardHousesDebtPDF
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reporte a generar
  * @return The full HTTP response as Observable
  */
  public dashboardHousesDebtPDF(Authorization: string, idCondominium: number, body: HousesDebtPDFRequest): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/housesdebtpdf`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method dashboardHousesDebtCondominiumsSons
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idConcept The ID del concepto, 0 es mantenimiento
  * @param month1 The mes inicio
  * @param year1 The año inicio
  * @param month2 The mes fin
  * @param year2 The año fin
  * @return The full HTTP response as Observable
  */
  public dashboardHousesDebtCondominiumsSons(Authorization: string, idCondominium: number, idConcept: number, month1: number, year1: number, month2: number, year2: number): Observable<HttpResponse<AllDashboardHousesDebtCondominiumSonsResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/housesdebtcondominiumsons/${idConcept}/${month1}/${year1}/${month2}/${year2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDashboardHousesDebtCondominiumSonsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method dashboardBalancereport
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month1 The mes inicio
  * @param year1 The año inicio
  * @param month2 The mes fin
  * @param year2 The año fin
  * @return The full HTTP response as Observable
  */
  public dashboardBalancereport(Authorization: string, idCondominium: number, month1: number, year1: number, month2: number, year2: number): Observable<HttpResponse<AllDashboardBalanceReportResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/balancereport/${month1}/${year1}/${month2}/${year2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDashboardBalanceReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method dashboardBalancereportpdf
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reporte a generar
  * @return The full HTTP response as Observable
  */
  public dashboardBalancereportpdf(Authorization: string, idCondominium: number, body: BalanceReportPDFRequest): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/balancereportpdf`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method dashboardBalance
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month1 The mes inicio
  * @param year1 The año inicio
  * @param month2 The mes fin
  * @param year2 The año fin
  * @return The full HTTP response as Observable
  */
  public dashboardBalance(Authorization: string, idCondominium: number, month1: number, year1: number, month2: number, year2: number): Observable<HttpResponse<AllDashboardBalanceResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/balance/${month1}/${year1}/${month2}/${year2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDashboardBalanceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method dashboardBalancepdf
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reporte a generar
  * @return The full HTTP response as Observable
  */
  public dashboardBalancepdf(Authorization: string, idCondominium: number, body: BalanceReportPDFRequest): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/balancepdf`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method dashboardBalanceExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reporte a generar
  * @return The full HTTP response as Observable
  */
  public dashboardBalanceExcel(Authorization: string, idCondominium: number, body: BalanceReportPDFRequest): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/dashboard/balanceexcel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method news
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public news(Authorization: string, idCondominium: number): Observable<HttpResponse<AllNewsResponse>> {
    let uri = `/condominium/${idCondominium}/news`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllNewsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createNews
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la noticia a registrar
  * @return The full HTTP response as Observable
  */
  public createNews(Authorization: string, idCondominium: number, body: CreateNewsRequest): Observable<HttpResponse<CreateUpdateNewsResponse>> {
    let uri = `/condominium/${idCondominium}/news`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateNewsResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateNews
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la noticia a modificar
  * @return The full HTTP response as Observable
  */
  public updateNews(Authorization: string, idCondominium: number, body: UpdateNewsRequest): Observable<HttpResponse<CreateUpdateNewsResponse>> {
    let uri = `/condominium/${idCondominium}/news`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateNewsResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteNews
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idNews The ID de la noticia
  * @return The full HTTP response as Observable
  */
  public deleteNews(Authorization: string, idCondominium: number, idNews: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/news/${idNews}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method events
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public events(Authorization: string, idCondominium: number): Observable<HttpResponse<AllEventsResponse>> {
    let uri = `/condominium/${idCondominium}/event`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEventsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createEvent
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del evento a registrar
  * @return The full HTTP response as Observable
  */
  public createEvent(Authorization: string, idCondominium: number, body: CreateEventRequest): Observable<HttpResponse<CreateUpdateEventResponse>> {
    let uri = `/condominium/${idCondominium}/event`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateEventResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateEvent
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del usuario a modificar
  * @return The full HTTP response as Observable
  */
  public updateEvent(Authorization: string, idCondominium: number, body: UpdateEventRequest): Observable<HttpResponse<CreateUpdateEventResponse>> {
    let uri = `/condominium/${idCondominium}/event`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateEventResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteEvent
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idEvent The ID del usuario
  * @return The full HTTP response as Observable
  */
  public deleteEvent(Authorization: string, idCondominium: number, idEvent: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/event/${idEvent}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method emergency
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public emergency(Authorization: string, idCondominium: number): Observable<HttpResponse<AllEmergencyResponse>> {
    let uri = `/condominium/${idCondominium}/emergency`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEmergencyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateEmergency
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la emergencia a modificar
  * @return The full HTTP response as Observable
  */
  public updateEmergency(Authorization: string, idCondominium: number, body: UpdateEmergencyRequest): Observable<HttpResponse<CreateUpdateEmergencyResponse>> {
    let uri = `/condominium/${idCondominium}/emergency`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateEmergencyResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteEmergency
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idEmergency The ID de la emergencia
  * @return The full HTTP response as Observable
  */
  public deleteEmergency(Authorization: string, idCondominium: number, idEmergency: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/emergency/${idEmergency}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method addIncidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de busqueda
  * @return The full HTTP response as Observable
  */
  public addIncidence(Authorization: string, idCondominium: number, body: IncidenceRequest): Observable<HttpResponse<CreateUpdateIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/addincidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateIncidenceResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method incidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de busqueda
  * @return The full HTTP response as Observable
  */
  public incidence(Authorization: string, idCondominium: number, body: SearchIncidenceRequest): Observable<HttpResponse<AllIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/incidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllIncidenceResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateIncidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la incidencia a modificar
  * @return The full HTTP response as Observable
  */
  public updateIncidence(Authorization: string, idCondominium: number, body: UpdateIncidenceRequest): Observable<HttpResponse<CreateUpdateIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/incidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateIncidenceResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteIncidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idIncidence The ID de la incidencia
  * @return The full HTTP response as Observable
  */
  public deleteIncidence(Authorization: string, idCondominium: number, idIncidence: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/incidence/${idIncidence}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method pdfReportIncidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idIncidence The ID de la incidencia
  * @return The full HTTP response as Observable
  */
  public pdfReportIncidence(Authorization: string, idCondominium: number, idIncidence: number): Observable<HttpResponse<CommonPDFReportResponse>> {
    let uri = `/condominium/${idCondominium}/pdfreportincidence/${idIncidence}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonPDFReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method incidenceexcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de busqueda
  * @return The full HTTP response as Observable
  */
  public incidenceexcel(Authorization: string, idCondominium: number, body: SearchIncidenceRequest): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/incidenceexcel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method incidencenote
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idIncidence The ID de la incidencia padre
  * @return The full HTTP response as Observable
  */
  public incidencenote(Authorization: string, idCondominium: number, idIncidence: number): Observable<HttpResponse<AllIncidenceNoteResponse>> {
    let uri = `/condominium/${idCondominium}/incidencenote/${idIncidence}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllIncidenceNoteResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createIncidenceNote
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idIncidence The ID de la incidencia padre
  * @param body The Datos del evento a registrar
  * @return The full HTTP response as Observable
  */
  public createIncidenceNote(Authorization: string, idCondominium: number, idIncidence: number, body: CreateIncidenceNoteRequest): Observable<HttpResponse<CreateUpdateIncidenceNoteResponse>> {
    let uri = `/condominium/${idCondominium}/incidencenote/${idIncidence}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateIncidenceNoteResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteIncidenceNote
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idIncidenceNote The ID de la incidencia padre
  * @return The full HTTP response as Observable
  */
  public deleteIncidenceNote(Authorization: string, idCondominium: number, idIncidenceNote: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/incidencenotedelete/${idIncidenceNote}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method reportStatus
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public reportStatus(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/report_status`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method regimenFiscal
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public regimenFiscal(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/regimen_fiscal`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportArea
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public reportArea(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/report_area`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method typeService
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public typeService(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/type_service`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method typeResident
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public typeResident(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/type_resident`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method typeHouse
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public typeHouse(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/type_house`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method typeNotification
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public typeNotification(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/type_notification`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method recurrencePayment
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public recurrencePayment(Authorization: string): Observable<HttpResponse<AllCatalogWithCantResponse>> {
    let uri = `/recurrence_payment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogWithCantResponse>('get', uri, headers, params, null);
  }

  /**
  * Method stateCharge
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public stateCharge(Authorization: string): Observable<HttpResponse<AllCatalogResponse>> {
    let uri = `/state_charge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCatalogResponse>('get', uri, headers, params, null);
  }

  /**
  * Method project
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public project(Authorization: string, idCondominium: number): Observable<HttpResponse<AllProjectResponse>> {
    let uri = `/condominium/${idCondominium}/project`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllProjectResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createProject
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del proyecto a registrar
  * @return The full HTTP response as Observable
  */
  public createProject(Authorization: string, idCondominium: number, body: CreateProjectRequest): Observable<HttpResponse<CreateUpdateProjectResponse>> {
    let uri = `/condominium/${idCondominium}/project`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateProjectResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del proyecto a modificar
  * @return The full HTTP response as Observable
  */
  public updateProject(Authorization: string, idCondominium: number, body: UpdateProjectRequest): Observable<HttpResponse<CreateUpdateProjectResponse>> {
    let uri = `/condominium/${idCondominium}/project`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateProjectResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idProject The ID del proyecto
  * @return The full HTTP response as Observable
  */
  public deleteProject(Authorization: string, idCondominium: number, idProject: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/project/${idProject}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method closeProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idProject The ID del proyecto
  * @return The full HTTP response as Observable
  */
  public closeProject(Authorization: string, idCondominium: number, idProject: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/project/${idProject}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method projetReport
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del proyecto
  * @return The full HTTP response as Observable
  */
  public projetReport(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<ExcelResponse>> {
    let uri = `/condominium/${idCondominium}/report/project/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelResponse>('get', uri, headers, params, null);
  }

  /**
  * Method email
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public email(Authorization: string, idCondominium: number): Observable<HttpResponse<AllEmailResponse>> {
    let uri = `/condominium/${idCondominium}/email`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEmailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createEmail
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del email a registrar
  * @return The full HTTP response as Observable
  */
  public createEmail(Authorization: string, idCondominium: number, body: CreateEmailRequest): Observable<HttpResponse<CreateUpdateEmailResponse>> {
    let uri = `/condominium/${idCondominium}/email`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateEmailResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateEmail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del email a modificar
  * @return The full HTTP response as Observable
  */
  public updateEmail(Authorization: string, idCondominium: number, body: UpdateEmailRequest): Observable<HttpResponse<CreateUpdateEmailResponse>> {
    let uri = `/condominium/${idCondominium}/email`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateEmailResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteEmail
  * @param Authorization The Frakcio Admin
  * @param idEmail The ID del email
  * @return The full HTTP response as Observable
  */
  public deleteEmail(Authorization: string, idEmail: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/email/${idEmail}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method phone
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public phone(Authorization: string, idCondominium: number): Observable<HttpResponse<AllPhoneResponse>> {
    let uri = `/condominium/${idCondominium}/phone`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPhoneResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createPhone
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del telefono a registrar
  * @return The full HTTP response as Observable
  */
  public createPhone(Authorization: string, idCondominium: number, body: CreatePhoneRequest): Observable<HttpResponse<CreateUpdatePhoneResponse>> {
    let uri = `/condominium/${idCondominium}/phone`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdatePhoneResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updatePhone
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del telefono a modificar
  * @return The full HTTP response as Observable
  */
  public updatePhone(Authorization: string, idCondominium: number, body: UpdatePhoneRequest): Observable<HttpResponse<CreateUpdatePhoneResponse>> {
    let uri = `/condominium/${idCondominium}/phone`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdatePhoneResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deletePhone
  * @param Authorization The Frakcio Admin
  * @param idPhone The ID del telefono
  * @return The full HTTP response as Observable
  */
  public deletePhone(Authorization: string, idPhone: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/phone/${idPhone}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method configEmail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public configEmail(Authorization: string, idCondominium: number): Observable<HttpResponse<AllConfigEmailResponse>> {
    let uri = `/condominium/${idCondominium}/config_email`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllConfigEmailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createConfigEmail
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del email a registrar
  * @return The full HTTP response as Observable
  */
  public createConfigEmail(Authorization: string, idCondominium: number, body: CreateConfigEmailRequest): Observable<HttpResponse<CreateUpdateConfigEmailResponse>> {
    let uri = `/condominium/${idCondominium}/config_email`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConfigEmailResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateConfigEmail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del email a modificar
  * @return The full HTTP response as Observable
  */
  public updateConfigEmail(Authorization: string, idCondominium: number, body: UpdateConfigEmailRequest): Observable<HttpResponse<CreateUpdateConfigEmailResponse>> {
    let uri = `/condominium/${idCondominium}/config_email`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConfigEmailResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteConfigEmail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idConfigEmail The ID Config email
  * @return The full HTTP response as Observable
  */
  public deleteConfigEmail(Authorization: string, idCondominium: number, idConfigEmail: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/config_email/${idConfigEmail}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method configPhone
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public configPhone(Authorization: string, idCondominium: number): Observable<HttpResponse<AllConfigPhoneResponse>> {
    let uri = `/condominium/${idCondominium}/config_phone`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllConfigPhoneResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createConfigPhone
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del telefono a registrar
  * @return The full HTTP response as Observable
  */
  public createConfigPhone(Authorization: string, idCondominium: number, body: CreateConfigPhoneRequest): Observable<HttpResponse<CreateUpdateConfigPhoneResponse>> {
    let uri = `/condominium/${idCondominium}/config_phone`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConfigPhoneResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateConfigPhone
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del telefono a modificar
  * @return The full HTTP response as Observable
  */
  public updateConfigPhone(Authorization: string, idCondominium: number, body: UpdateConfigPhoneRequest): Observable<HttpResponse<CreateUpdateConfigPhoneResponse>> {
    let uri = `/condominium/${idCondominium}/config_phone`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConfigPhoneResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteConfigPhone
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idConfigPhone The ID del telefono
  * @return The full HTTP response as Observable
  */
  public deleteConfigPhone(Authorization: string, idCondominium: number, idConfigPhone: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/config_phone/${idConfigPhone}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method configPayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public configPayment(Authorization: string, idCondominium: number): Observable<HttpResponse<AllConfigPaymentResponse>> {
    let uri = `/condominium/${idCondominium}/config_payment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllConfigPaymentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateConfigPayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del telefono a modificar
  * @return The full HTTP response as Observable
  */
  public updateConfigPayment(Authorization: string, idCondominium: number, body: UpdateConfigPaymentRequest): Observable<HttpResponse<CreateUpdateConfigPaymentResponse>> {
    let uri = `/condominium/${idCondominium}/config_payment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConfigPaymentResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method chargeexcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The ID del estado
  * @param date2 The ID del estado
  * @param idState The ID del estado
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public chargeexcel(Authorization: string, idCondominium: number, date1: string, date2: string, idState: number, idHouse: number): Observable<HttpResponse<ExcelResponse>> {
    let uri = `/condominium/${idCondominium}/chargeexcel/${date1}/${date2}/${idState}/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelResponse>('get', uri, headers, params, null);
  }

  /**
  * Method charge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The ID del estado
  * @param date2 The ID del estado
  * @param idState The ID del estado
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public charge(Authorization: string, idCondominium: number, date1: string, date2: string, idState: number, idHouse: number): Observable<HttpResponse<AllChargeResponse>> {
    let uri = `/condominium/${idCondominium}/charge/${date1}/${date2}/${idState}/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllChargeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method chargewithoutformat
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idState The ID del estado
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public chargewithoutformat(Authorization: string, idCondominium: number, idState: number, idHouse: number): Observable<HttpResponse<AllChargeWithoutFormatResponse>> {
    let uri = `/condominium/${idCondominium}/chargewithoutformat/${idHouse}/${idState}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllChargeWithoutFormatResponse>('get', uri, headers, params, null);
  }

  /**
  * Method paymentsbycharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCharge The ID del cargo
  * @return The full HTTP response as Observable
  */
  public paymentsbycharge(Authorization: string, idCondominium: number, idCharge: number): Observable<HttpResponse<PaymentsByChargeResponse>> {
    let uri = `/condominium/${idCondominium}/paymentsbycharge/${idCharge}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PaymentsByChargeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method cancelpositivepayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPayment The ID del pago a cancelar
  * @return The full HTTP response as Observable
  */
  public cancelpositivepayment(Authorization: string, idCondominium: number, idPayment: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/positivepayment/${idPayment}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method positivebalanceinconcepts
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public positivebalanceinconcepts(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<PositiveBalanceInConceptsResponse>> {
    let uri = `/condominium/${idCondominium}/positivebalanceinconcepts/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PositiveBalanceInConceptsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method paymentdefault
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public paymentdefault(Authorization: string, idCondominium: number): Observable<HttpResponse<PaymentDefaultResponse>> {
    let uri = `/condominium/${idCondominium}/paymentdefault`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PaymentDefaultResponse>('get', uri, headers, params, null);
  }

  /**
  * Method multiplepay
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del pago a modificar
  * @return The full HTTP response as Observable
  */
  public multiplepay(Authorization: string, idCondominium: number, body: CreateMultiplePayRequestRequest): Observable<HttpResponse<MultiplePayResponse>> {
    let uri = `/condominium/${idCondominium}/multiplepay`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<MultiplePayResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method paybyconcept
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del pago a modificar
  * @return The full HTTP response as Observable
  */
  public paybyconcept(Authorization: string, idCondominium: number, body: PayByConceptRequest): Observable<HttpResponse<PayByConceptResponse>> {
    let uri = `/condominium/${idCondominium}/paybyconcept`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PayByConceptResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deletepayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de para cancelar pago
  * @return The full HTTP response as Observable
  */
  public deletepayment(Authorization: string, idCondominium: number, body: CancelPaymentsRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/payment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editpayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de para cancelar pago
  * @return The full HTTP response as Observable
  */
  public editpayment(Authorization: string, idCondominium: number, body: UpdatePaymentsRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/editpayment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method paymentstocancel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param typeSearch The tipo de búsqueda
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param type The ID de la casa
  * @param folio The ID de la casa
  * @return The full HTTP response as Observable
  */
  public paymentstocancel(Authorization: string, idCondominium: number, typeSearch: number, date1: string, date2: string, idHouse: number, type: number, folio: number): Observable<HttpResponse<PaymentstoCancelResponse>> {
    let uri = `/condominium/${idCondominium}/paymentstocancel/${typeSearch}/${date1}/${date2}/${idHouse}/${type}/${folio}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PaymentstoCancelResponse>('get', uri, headers, params, null);
  }

  /**
  * Method paymentinvoice
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPayment The ID del pago
  * @param idFiscalInfo The ID fiscal de cliente
  * @return The full HTTP response as Observable
  */
  public paymentinvoice(Authorization: string, idCondominium: number, idPayment: number, idFiscalInfo: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/paymentinvoice/${idPayment}/${idFiscalInfo}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method chargesbypayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPayment The id del pago
  * @return The full HTTP response as Observable
  */
  public chargesbypayment(Authorization: string, idCondominium: number, idPayment: number): Observable<HttpResponse<ChargesByPaymentResponse>> {
    let uri = `/condominium/${idCondominium}/chargesbypayment/${idPayment}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ChargesByPaymentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method getadvancedpayments
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param body The Datos del pago a modificar
  * @return The full HTTP response as Observable
  */
  public getadvancedpayments(Authorization: string, idCondominium: number, idHouse: number, body: AdvancedPaymentsRequest): Observable<HttpResponse<AdvancedPaymentsResponse>> {
    let uri = `/condominium/${idCondominium}/getadvancedpayments/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AdvancedPaymentsResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method paymentreceipt
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPayment The ID del pago
  * @return The full HTTP response as Observable
  */
  public paymentreceipt(Authorization: string, idCondominium: number, idPayment: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/paymentreceipt/${idPayment}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method cancelAndRecreateInvoice
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del pago a modificar
  * @return The full HTTP response as Observable
  */
  public cancelAndRecreateInvoice(Authorization: string, idCondominium: number, body: CancelAndRcreateInvoiceRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/cancelandrecreateinvoice`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method unlinkInvoice
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPayment The ID del pago
  * @return The full HTTP response as Observable
  */
  public unlinkInvoice(Authorization: string, idCondominium: number, idPayment: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/payment/unlinkinvoice/${idPayment}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method linkInvoice
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPayment The ID del pago
  * @param idInvoice The ID de la factura
  * @return The full HTTP response as Observable
  */
  public linkInvoice(Authorization: string, idCondominium: number, idPayment: number, idInvoice: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/payment/linkinvoice/${idPayment}/${idInvoice}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method updateStateCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del pago a modificar
  * @return The full HTTP response as Observable
  */
  public updateStateCharge(Authorization: string, idCondominium: number, body: UpdateStateChargeRequest): Observable<HttpResponse<CreateUpdateStateChargeResponse>> {
    let uri = `/condominium/${idCondominium}/charge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateStateChargeResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method createCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del pago a modificar
  * @return The full HTTP response as Observable
  */
  public createCharge(Authorization: string, idCondominium: number, body: CreateHistoryChargesRequest): Observable<HttpResponse<ChargesResponse>> {
    let uri = `/condominium/${idCondominium}/charge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ChargesResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del pago a modificar
  * @return The full HTTP response as Observable
  */
  public updateCharge(Authorization: string, idCondominium: number, body: UpdateChargeRequest): Observable<HttpResponse<AllChargeResponse>> {
    let uri = `/condominium/${idCondominium}/updatecharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllChargeResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del cargo a cancelar
  * @param isCheckReverseMovement The Se guardara movimiento al eliminar
  * @param dateReverseMovement The Fecha del movimiento a eliminar
  * @return The full HTTP response as Observable
  */
  public deleteCharge(Authorization: string, idCondominium: number, id: number, isCheckReverseMovement: boolean, dateReverseMovement: string): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/charge/${id}/${isCheckReverseMovement}/${dateReverseMovement}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method updateDescriptionCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del pago a modificar
  * @return The full HTTP response as Observable
  */
  public updateDescriptionCharge(Authorization: string, idCondominium: number, body: UpdateDescriptionChargeRequest): Observable<HttpResponse<AllChargeResponse>> {
    let uri = `/condominium/${idCondominium}/updatedescriptioncharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllChargeResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method chargesimportexcel
  * @param Authorization The access token.
  * @param body The Excel a importar de cargos
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public chargesimportexcel(Authorization: string, body: ChargesImportExcelRequest, idCondominium: number): Observable<HttpResponse<ChargesImportExcelResponse>> {
    let uri = `/condominium/${idCondominium}/importcharges`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ChargesImportExcelResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method getInvitationByToken
  * @param token The token de la invitación
  * @return The full HTTP response as Observable
  */
  public getInvitationByToken(token: string): Observable<HttpResponse<InvitationUploadFilesResponse>> {
    let uri = `/publicactions/invitation/${token}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<InvitationUploadFilesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method uploadFaceAndIDInvitation
  * @param token The token de la invitación
  * @param body The Campos para editar la credencial de invitación
  * @return The full HTTP response as Observable
  */
  public uploadFaceAndIDInvitation(token: string, body: InvitationUploadFilesRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/publicactions/invitation/${token}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateIDInvitation
  * @param token The token de la invitación
  * @param body The Campos para editar la credencial de invitación
  * @return The full HTTP response as Observable
  */
  public updateIDInvitation(token: string, body: InvitationUpdateFilesRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/publicactions/invitation/update/${token}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateFacePhotoInvitation
  * @param token The token de la invitación
  * @param body The Campos para editar la foto del rostro
  * @return The full HTTP response as Observable
  */
  public updateFacePhotoInvitation(token: string, body: InvitationUpdateFacePhotoRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/publicactions/invitation/updatefacephoto/${token}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method acceptPrivacyPolicyInvitation
  * @param token The token de la invitación
  * @return The full HTTP response as Observable
  */
  public acceptPrivacyPolicyInvitation(token: string): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/publicactions/invitation/acceptprivacynotice/${token}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method checkValidFaceInvitation
  * @param token The token de la invitación
  * @param body The Campos para editar la foto del rostro
  * @return The full HTTP response as Observable
  */
  public checkValidFaceInvitation(token: string, body: InvitationCheckValidFaceRequest): Observable<HttpResponse<DataBooleanResponse>> {
    let uri = `/publicactions/invitation/checkvalidface/${token}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<DataBooleanResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method checkValidIdentificationInvitation
  * @param token The token de la invitación
  * @param body The Campos para verificar la credencial
  * @return The full HTTP response as Observable
  */
  public checkValidIdentificationInvitation(token: string, body: InvitationCheckValidIdentificationRequest): Observable<HttpResponse<CheckValidIdentificationResponse>> {
    let uri = `/publicactions/invitation/checkvalididentification/${token}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    return this.sendRequest<CheckValidIdentificationResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method chargespaymentsimportexcel
  * @param Authorization The access token.
  * @param body The Excel a importar cargos y pagos
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public chargespaymentsimportexcel(Authorization: string, body: ChargesImportExcelRequest, idCondominium: number): Observable<HttpResponse<ChargesImportExcelResponse>> {
    let uri = `/condominium/${idCondominium}/importchargespayments`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ChargesImportExcelResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method expensesimportexcel
  * @param Authorization The access token.
  * @param body The Excel gastos
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public expensesimportexcel(Authorization: string, body: ChargesImportExcelRequest, idCondominium: number): Observable<HttpResponse<ChargesImportExcelResponse>> {
    let uri = `/condominium/${idCondominium}/importexpenses`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ChargesImportExcelResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method useradmin
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public useradmin(Authorization: string, idCondominium: number): Observable<HttpResponse<AllUserAdminResponse>> {
    let uri = `/condominium/${idCondominium}/user`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllUserAdminResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createUserAdmin
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del usuario administrador a registrar
  * @return The full HTTP response as Observable
  */
  public createUserAdmin(Authorization: string, idCondominium: number, body: CreateUserAdminRequest): Observable<HttpResponse<CreateUpdateUserAdminResponse>> {
    let uri = `/condominium/${idCondominium}/user`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateUserAdminResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method UpdateUserAdmin
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del usuario administrador a modificar
  * @return The full HTTP response as Observable
  */
  public UpdateUserAdmin(Authorization: string, idCondominium: number, body: UpdateUserAdminRequest): Observable<HttpResponse<CreateUpdateUserAdminResponse>> {
    let uri = `/condominium/${idCondominium}/user`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateUserAdminResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method DeleteUserAdmin
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idUser The ID del usuario
  * @return The full HTTP response as Observable
  */
  public DeleteUserAdmin(Authorization: string, idCondominium: number, idUser: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/user/${idUser}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method house
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idResident The ID del residente (por defecto en 0)
  * @return The full HTTP response as Observable
  */
  public house(Authorization: string, idCondominium: number, idResident: number): Observable<HttpResponse<AllHouseResponse>> {
    let uri = `/condominium/${idCondominium}/resident/${idResident}/house`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createHouse
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la casa a registrar
  * @return The full HTTP response as Observable
  */
  public createHouse(Authorization: string, idCondominium: number, body: CreateHouseRequest): Observable<HttpResponse<CreateUpdateHouseResponse>> {
    let uri = `/condominium/${idCondominium}/house`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateHouseResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method UpdateHouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la casa a modificar
  * @return The full HTTP response as Observable
  */
  public UpdateHouse(Authorization: string, idCondominium: number, body: UpdateHouseRequest): Observable<HttpResponse<CreateUpdateHouseResponse>> {
    let uri = `/condominium/${idCondominium}/house`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateHouseResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method DeleteHouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public DeleteHouse(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/house/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method houseservice
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public houseservice(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllHouseServiceResponse>> {
    let uri = `/condominium/${idCondominium}/houseservice/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHouseServiceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateHouseService
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param body The Datos de los servicios
  * @return The full HTTP response as Observable
  */
  public updateHouseService(Authorization: string, idCondominium: number, idHouse: number, body: UpdateHouseServiceRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/houseservice/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method houseaccount
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public houseaccount(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllHouseAccountResponse>> {
    let uri = `/condominium/${idCondominium}/houseaccount/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHouseAccountResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateHouseAccount
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de las cuentas
  * @return The full HTTP response as Observable
  */
  public updateHouseAccount(Authorization: string, idCondominium: number, body: UpdateHouseAccountRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/houseaccount`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method houseExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public houseExcel(Authorization: string, idCondominium: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/house/excel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method listhouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public listhouse(Authorization: string, idCondominium: number): Observable<HttpResponse<AllListHouseResponse>> {
    let uri = `/condominium/${idCondominium}/listhouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllListHouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createlisthouse
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la lista
  * @return The full HTTP response as Observable
  */
  public createlisthouse(Authorization: string, idCondominium: number, body: CreateListHouseRequest): Observable<HttpResponse<CreateUpdateListHouseResponse>> {
    let uri = `/condominium/${idCondominium}/listhouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateListHouseResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editlisthouse
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la lista
  * @return The full HTTP response as Observable
  */
  public editlisthouse(Authorization: string, idCondominium: number, body: UpdateListHouseRequest): Observable<HttpResponse<CreateUpdateListHouseResponse>> {
    let uri = `/condominium/${idCondominium}/listhouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateListHouseResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method DeleteListHouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idListHouse The ID de la lista de casas
  * @return The full HTTP response as Observable
  */
  public DeleteListHouse(Authorization: string, idCondominium: number, idListHouse: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/listhouse/${idListHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method listhouse_house
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idListHouse The ID del listado
  * @return The full HTTP response as Observable
  */
  public listhouse_house(Authorization: string, idCondominium: number, idListHouse: number): Observable<HttpResponse<AllListHouse_HouseResponse>> {
    let uri = `/condominium/${idCondominium}/listhouse_house/${idListHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllListHouse_HouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method account
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public account(Authorization: string, idCondominium: number): Observable<HttpResponse<AllAccountResponse>> {
    let uri = `/condominium/${idCondominium}/account`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllAccountResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createAccount
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la cuenta a registrar
  * @return The full HTTP response as Observable
  */
  public createAccount(Authorization: string, idCondominium: number, body: CreateAccountRequest): Observable<HttpResponse<CreateUpdateAccountResponse>> {
    let uri = `/condominium/${idCondominium}/account`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateAccountResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateAccount
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la cuenta a modificar
  * @return The full HTTP response as Observable
  */
  public updateAccount(Authorization: string, idCondominium: number, body: UpdateAccountRequest): Observable<HttpResponse<CreateUpdateAccountResponse>> {
    let uri = `/condominium/${idCondominium}/account`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateAccountResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteAccount
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idAccount The ID de la cuenta
  * @return The full HTTP response as Observable
  */
  public deleteAccount(Authorization: string, idCondominium: number, idAccount: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/account/${idAccount}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method accountbycharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCharge The ID del cargo
  * @param idTypePayment The ID del tipo de pago
  * @return The full HTTP response as Observable
  */
  public accountbycharge(Authorization: string, idCondominium: number, idCharge: number, idTypePayment: number): Observable<HttpResponse<AllAccountByChargeResponse>> {
    let uri = `/condominium/${idCondominium}/accountbycharge/${idCharge}/${idTypePayment}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllAccountByChargeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method accountmovement
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idAccount The ID de cuenta bancaria
  * @param date1 The fecha inicio
  * @param date2 The fecha final
  * @return The full HTTP response as Observable
  */
  public accountmovement(Authorization: string, idCondominium: number, idAccount: number, date1: string, date2: string): Observable<HttpResponse<AllAccountMovementResponse>> {
    let uri = `/condominium/${idCondominium}/accountmovement/${idAccount}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllAccountMovementResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createAccountMovement
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idAccount The ID de la cuenta
  * @param body The Datos de la cuenta a registrar
  * @return The full HTTP response as Observable
  */
  public createAccountMovement(Authorization: string, idCondominium: number, idAccount: number, body: CreateAccountMovementRequest): Observable<HttpResponse<CreateUpdateAccountMovementResponse>> {
    let uri = `/condominium/${idCondominium}/accountmovement/${idAccount}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateAccountMovementResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method createTransfer
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idAccount The ID de la cuenta
  * @param body The Datos de la cuenta a registrar
  * @return The full HTTP response as Observable
  */
  public createTransfer(Authorization: string, idCondominium: number, idAccount: number, body: CreateTransferRequest): Observable<HttpResponse<CreateUpdateTransferResponse>> {
    let uri = `/condominium/${idCondominium}/accountmovementtransfer/${idAccount}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateTransferResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteAccountMovement
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del movimiento
  * @return The full HTTP response as Observable
  */
  public deleteAccountMovement(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/accountmovementdelete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method deleteAccountMovementTransfer
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del movimiento
  * @return The full HTTP response as Observable
  */
  public deleteAccountMovementTransfer(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/accountmovementtransferdelete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method concept
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public concept(Authorization: string, idCondominium: number): Observable<HttpResponse<AllConceptResponse>> {
    let uri = `/condominium/${idCondominium}/concept`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllConceptResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createConcept
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la cuenta a registrar
  * @return The full HTTP response as Observable
  */
  public createConcept(Authorization: string, idCondominium: number, body: CreateConceptRequest): Observable<HttpResponse<CreateUpdateConceptResponse>> {
    let uri = `/condominium/${idCondominium}/concept`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConceptResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateConcept
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de concepto a modificar
  * @return The full HTTP response as Observable
  */
  public updateConcept(Authorization: string, idCondominium: number, body: UpdateConceptRequest): Observable<HttpResponse<CreateUpdateConceptResponse>> {
    let uri = `/condominium/${idCondominium}/concept`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConceptResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteConcept
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idConcept The ID de concepto
  * @return The full HTTP response as Observable
  */
  public deleteConcept(Authorization: string, idCondominium: number, idConcept: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/concept/${idConcept}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method estimate
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public estimate(Authorization: string, idCondominium: number): Observable<HttpResponse<AllEstimateResponse>> {
    let uri = `/condominium/${idCondominium}/estimate`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEstimateResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createEstimate
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del prespuesto
  * @return The full HTTP response as Observable
  */
  public createEstimate(Authorization: string, idCondominium: number, body: CreateEstimateRequest): Observable<HttpResponse<CreateUpdateEstimateResponse>> {
    let uri = `/condominium/${idCondominium}/estimate`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateEstimateResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateEstimate
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de estimación a modificar
  * @return The full HTTP response as Observable
  */
  public updateEstimate(Authorization: string, idCondominium: number, body: UpdateEstimateRequest): Observable<HttpResponse<CreateUpdateEstimateResponse>> {
    let uri = `/condominium/${idCondominium}/estimate`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateEstimateResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteEstimate
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de presupuesto
  * @return The full HTTP response as Observable
  */
  public deleteEstimate(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/estimate/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method estimateconcept
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idEstimate The ID de la estimación
  * @return The full HTTP response as Observable
  */
  public estimateconcept(Authorization: string, idCondominium: number, idEstimate: number): Observable<HttpResponse<AllEstimateConceptResponse>> {
    let uri = `/condominium/${idCondominium}/estimateconcept/${idEstimate}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEstimateConceptResponse>('get', uri, headers, params, null);
  }

  /**
  * Method estimatetax
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idEstimate The ID de la estimación
  * @return The full HTTP response as Observable
  */
  public estimatetax(Authorization: string, idCondominium: number, idEstimate: number): Observable<HttpResponse<AllEstimateTaxResponse>> {
    let uri = `/condominium/${idCondominium}/estimatetax/${idEstimate}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEstimateTaxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelyearestimate
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idEstimate The id del presupuesto
  * @return The full HTTP response as Observable
  */
  public excelyearestimate(Authorization: string, idCondominium: number, idEstimate: number): Observable<HttpResponse<ExcelResponse>> {
    let uri = `/condominium/${idCondominium}/yearestimate/${idEstimate}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelEstimateFile
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPresupuesto The ID del presupuesto
  * @param type The 0 para obtener excel vacio. 1 para obtener modificar
  * @return The full HTTP response as Observable
  */
  public excelEstimateFile(Authorization: string, idCondominium: number, idPresupuesto: number, type: number): Observable<HttpResponse<ExcelResponse>> {
    let uri = `/condominium/${idCondominium}/getEstimateExcelFile/${idPresupuesto}/${type}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelResponse>('get', uri, headers, params, null);
  }

  /**
  * Method estimateImportExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPresupuesto The ID del presupuesto
  * @param body The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public estimateImportExcel(Authorization: string, idCondominium: number, idPresupuesto: number, body: EstimateExcel): Observable<HttpResponse<EstimateResponse>> {
    let uri = `/condominium/${idCondominium}/estimateImportExcel/${idPresupuesto}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<EstimateResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method conceptcategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public conceptcategory(Authorization: string, idCondominium: number): Observable<HttpResponse<AllConceptCategoryResponse>> {
    let uri = `/condominium/${idCondominium}/conceptcategory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllConceptCategoryResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createConceptCategory
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la categoría a registrar
  * @return The full HTTP response as Observable
  */
  public createConceptCategory(Authorization: string, idCondominium: number, body: CreateConceptCategoryRequest): Observable<HttpResponse<CreateUpdateConceptCategoryResponse>> {
    let uri = `/condominium/${idCondominium}/conceptcategory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConceptCategoryResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateConceptCategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de concepto a modificar
  * @return The full HTTP response as Observable
  */
  public updateConceptCategory(Authorization: string, idCondominium: number, body: UpdateConceptCategoryRequest): Observable<HttpResponse<CreateUpdateConceptCategoryResponse>> {
    let uri = `/condominium/${idCondominium}/conceptcategory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateConceptCategoryResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteConceptCategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de categoría
  * @return The full HTTP response as Observable
  */
  public deleteConceptCategory(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/conceptcategory/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method provider
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public provider(Authorization: string, idCondominium: number): Observable<HttpResponse<AllProviderResponse>> {
    let uri = `/condominium/${idCondominium}/provider`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllProviderResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createProvider
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del proveedor
  * @return The full HTTP response as Observable
  */
  public createProvider(Authorization: string, idCondominium: number, body: CreateProviderRequest): Observable<HttpResponse<CreateUpdateProviderResponse>> {
    let uri = `/condominium/${idCondominium}/provider`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateProviderResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateProvider
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de proveedor a editar
  * @return The full HTTP response as Observable
  */
  public updateProvider(Authorization: string, idCondominium: number, body: UpdateProviderRequest): Observable<HttpResponse<CreateUpdateProviderResponse>> {
    let uri = `/condominium/${idCondominium}/provider`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateProviderResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method providerExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public providerExcel(Authorization: string, idCondominium: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/provider/excel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method deleteProvider
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de proveedor
  * @return The full HTTP response as Observable
  */
  public deleteProvider(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/provider/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method areaincidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public areaincidence(Authorization: string, idCondominium: number): Observable<HttpResponse<AllAreaIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/areaincidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllAreaIncidenceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createAreaIncidence
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de área de incidencia
  * @return The full HTTP response as Observable
  */
  public createAreaIncidence(Authorization: string, idCondominium: number, body: CreateAreaIncidenceRequest): Observable<HttpResponse<CreateUpdateAreaIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/areaincidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateAreaIncidenceResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateAreaIncidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de área de incidencia a editar
  * @return The full HTTP response as Observable
  */
  public updateAreaIncidence(Authorization: string, idCondominium: number, body: UpdateAreaIncidenceRequest): Observable<HttpResponse<CreateUpdateAreaIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/areaincidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateAreaIncidenceResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteAreaIncidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de área de incidencia
  * @return The full HTTP response as Observable
  */
  public deleteAreaIncidence(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/areaincidence/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method typeincidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public typeincidence(Authorization: string, idCondominium: number): Observable<HttpResponse<AllTypeIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/typeincidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllTypeIncidenceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createTypeIncidence
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de área de incidencia
  * @return The full HTTP response as Observable
  */
  public createTypeIncidence(Authorization: string, idCondominium: number, body: CreateTypeIncidenceRequest): Observable<HttpResponse<CreateUpdateTypeIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/typeincidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateTypeIncidenceResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateTypeIncidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de tipo de incidencia a editar
  * @return The full HTTP response as Observable
  */
  public updateTypeIncidence(Authorization: string, idCondominium: number, body: UpdateTypeIncidenceRequest): Observable<HttpResponse<CreateUpdateTypeIncidenceResponse>> {
    let uri = `/condominium/${idCondominium}/typeincidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateTypeIncidenceResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteTypeIncidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de tipo de incidencia
  * @return The full HTTP response as Observable
  */
  public deleteTypeIncidence(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/typeincidence/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method incidenceresponsible
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idTypeIncidence The ID de tipo de incidencia
  * @return The full HTTP response as Observable
  */
  public incidenceresponsible(Authorization: string, idCondominium: number, idTypeIncidence: number): Observable<HttpResponse<AllIncidenceResponsibleResponse>> {
    let uri = `/condominium/${idCondominium}/typeincidence/responsible/${idTypeIncidence}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllIncidenceResponsibleResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createIncidenceResponsible
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del responsable
  * @return The full HTTP response as Observable
  */
  public createIncidenceResponsible(Authorization: string, idCondominium: number, body: CreateIncidenceResponsibleRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/typeincidence/responsible`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateIncidenceResponsible
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de tipo del responsable
  * @return The full HTTP response as Observable
  */
  public updateIncidenceResponsible(Authorization: string, idCondominium: number, body: UpdateIncidenceResponsibleRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/typeincidence/responsible`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteIncidenceResponsible
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de responsable
  * @return The full HTTP response as Observable
  */
  public deleteIncidenceResponsible(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/typeincidence/responsibledelete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method car
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The Id de casa
  * @return The full HTTP response as Observable
  */
  public car(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllCarResponse>> {
    let uri = `/condominium/${idCondominium}/car/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCarResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCar
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del carro
  * @return The full HTTP response as Observable
  */
  public createCar(Authorization: string, idCondominium: number, body: CreateCarRequest): Observable<HttpResponse<CreateUpdateCarResponse>> {
    let uri = `/condominium/${idCondominium}/car`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCarResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateCar
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de carro a editar
  * @return The full HTTP response as Observable
  */
  public updateCar(Authorization: string, idCondominium: number, body: UpdateCarRequest): Observable<HttpResponse<CreateUpdateCarResponse>> {
    let uri = `/condominium/${idCondominium}/car`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCarResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCar
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de carro
  * @return The full HTTP response as Observable
  */
  public deleteCar(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/car/delete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method carExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public carExcel(Authorization: string, idCondominium: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/excel/car`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method course
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public course(Authorization: string, idCondominium: number): Observable<HttpResponse<AllCourseResponse>> {
    let uri = `/condominium/${idCondominium}/course`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCourseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCourse
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del curso
  * @return The full HTTP response as Observable
  */
  public createCourse(Authorization: string, idCondominium: number, body: CreateCourseRequest): Observable<HttpResponse<CreateUpdateCourseResponse>> {
    let uri = `/condominium/${idCondominium}/course`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCourseResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateCourse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del curso a editar
  * @return The full HTTP response as Observable
  */
  public updateCourse(Authorization: string, idCondominium: number, body: UpdateCourseRequest): Observable<HttpResponse<CreateUpdateCourseResponse>> {
    let uri = `/condominium/${idCondominium}/course`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCourseResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCourse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del curso
  * @return The full HTTP response as Observable
  */
  public deleteCourse(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/course/delete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method courseById
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del curso
  * @return The full HTTP response as Observable
  */
  public courseById(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<CourseDetailResponse>> {
    let uri = `/condominium/${idCondominium}/course/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CourseDetailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method courseInstructor
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public courseInstructor(Authorization: string, idCondominium: number): Observable<HttpResponse<AllCourseInstructorResponse>> {
    let uri = `/condominium/${idCondominium}/courseinstructor`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCourseInstructorResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCourseInstructor
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del instructor de curso
  * @return The full HTTP response as Observable
  */
  public createCourseInstructor(Authorization: string, idCondominium: number, body: CreateCourseInstructorRequest): Observable<HttpResponse<CreateUpdateCourseInstructorResponse>> {
    let uri = `/condominium/${idCondominium}/courseinstructor`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCourseInstructorResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateCourseInstructor
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del instructor de curso a editar
  * @return The full HTTP response as Observable
  */
  public updateCourseInstructor(Authorization: string, idCondominium: number, body: UpdateCourseInstructorRequest): Observable<HttpResponse<CreateUpdateCourseInstructorResponse>> {
    let uri = `/condominium/${idCondominium}/courseinstructor`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCourseInstructorResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCourseInstructor
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del instructor de curso
  * @return The full HTTP response as Observable
  */
  public deleteCourseInstructor(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/courseinstructor/delete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method courseClass
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCourse The ID del curso
  * @return The full HTTP response as Observable
  */
  public courseClass(Authorization: string, idCondominium: number, idCourse: number): Observable<HttpResponse<AllCourseClassResponse>> {
    let uri = `/condominium/${idCondominium}/courseclass/${idCourse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCourseClassResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCourseClass
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la clase de curso
  * @return The full HTTP response as Observable
  */
  public createCourseClass(Authorization: string, idCondominium: number, body: CreateCourseClassRequest): Observable<HttpResponse<CreateUpdateCourseClassResponse>> {
    let uri = `/condominium/${idCondominium}/courseclass`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCourseClassResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateCourseClass
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la clase de curso a editar
  * @return The full HTTP response as Observable
  */
  public updateCourseClass(Authorization: string, idCondominium: number, body: UpdateCourseClassRequest): Observable<HttpResponse<CreateUpdateCourseClassResponse>> {
    let uri = `/condominium/${idCondominium}/courseclass`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCourseClassResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCourseClass
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de la clase de curso
  * @return The full HTTP response as Observable
  */
  public deleteCourseClass(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/courseclass/delete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method workerProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public workerProject(Authorization: string, idCondominium: number): Observable<HttpResponse<AllWorkerProjectResponse>> {
    let uri = `/condominium/${idCondominium}/workerProject`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllWorkerProjectResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createWorkerProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del proyecto de obra
  * @return The full HTTP response as Observable
  */
  public createWorkerProject(Authorization: string, idCondominium: number, body: CreateWorkerProjectRequest): Observable<HttpResponse<CreateUpdateWorkerProjectResponse>> {
    let uri = `/condominium/${idCondominium}/workerProject`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateWorkerProjectResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteWorkerProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idProject The ID del proyecto de obra
  * @return The full HTTP response as Observable
  */
  public deleteWorkerProject(Authorization: string, idCondominium: number, idProject: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/workerProject/${idProject}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method editWorkerProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idProject The ID del proyecto de obra
  * @param body The Datos del proyecto de obra a editar
  * @return The full HTTP response as Observable
  */
  public editWorkerProject(Authorization: string, idCondominium: number, idProject: number, body: UpdateWorkerProjectRequest): Observable<HttpResponse<CreateUpdateWorkerProjectResponse>> {
    let uri = `/condominium/${idCondominium}/workerProject/${idProject}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateWorkerProjectResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method workerUser
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idProject The ID del proyecto de obra
  * @return The full HTTP response as Observable
  */
  public workerUser(Authorization: string, idCondominium: number, idProject: number): Observable<HttpResponse<AllWorkerUserResponse>> {
    let uri = `/condominium/${idCondominium}/userWorker/project/${idProject}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllWorkerUserResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createWorkerUser
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del usuario de obra
  * @return The full HTTP response as Observable
  */
  public createWorkerUser(Authorization: string, idCondominium: number, body: CreateWorkerUserRequest): Observable<HttpResponse<CreateUpdateWorkerUserResponse>> {
    let uri = `/condominium/${idCondominium}/userWorker`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateWorkerUserResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method workerUserById
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idUserWorker The ID del usuario de obra
  * @return The full HTTP response as Observable
  */
  public workerUserById(Authorization: string, idCondominium: number, idUserWorker: number): Observable<HttpResponse<OneWorkerUserResponse>> {
    let uri = `/condominium/${idCondominium}/userWorker/${idUserWorker}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<OneWorkerUserResponse>('get', uri, headers, params, null);
  }

  /**
  * Method deleteWorkerUser
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idUserWorker The ID del usuario de obra
  * @return The full HTTP response as Observable
  */
  public deleteWorkerUser(Authorization: string, idCondominium: number, idUserWorker: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/userWorker/${idUserWorker}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method editWorkerUser
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idUserWorker The ID del usuario de obra
  * @param body The Datos del usuario de obra
  * @return The full HTTP response as Observable
  */
  public editWorkerUser(Authorization: string, idCondominium: number, idUserWorker: number, body: UpdateWorkerUserRequest): Observable<HttpResponse<CreateUpdateWorkerUserResponse>> {
    let uri = `/condominium/${idCondominium}/userWorker/${idUserWorker}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateWorkerUserResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method workerProjectByUser
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idUserWorker The ID del usuario de obra
  * @return The full HTTP response as Observable
  */
  public workerProjectByUser(Authorization: string, idCondominium: number, idUserWorker: number): Observable<HttpResponse<AllWorkerProjectUserResponse>> {
    let uri = `/condominium/${idCondominium}/workerProjectUser/projects/${idUserWorker}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllWorkerProjectUserResponse>('get', uri, headers, params, null);
  }

  /**
  * Method addWorkerProjectUser
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del usuario de obra
  * @return The full HTTP response as Observable
  */
  public addWorkerProjectUser(Authorization: string, idCondominium: number, body: CreateWorkerUserProjectAddRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/workerProjectUser`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteWorkerProjectUser
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del registro de proyecto asignado al usuario
  * @return The full HTTP response as Observable
  */
  public deleteWorkerProjectUser(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/workerProjectUser/delete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method workerUserCredential
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idUserWorker The ID del usuario a generar la credencial
  * @return The full HTTP response as Observable
  */
  public workerUserCredential(Authorization: string, idCondominium: number, idUserWorker: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/userWorker/${idUserWorker}/credential`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method sendWorkerUserEmail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idUserWorker The ID del usuario de obra a enviar el correo
  * @param body The Datos del usuario de obra
  * @return The full HTTP response as Observable
  */
  public sendWorkerUserEmail(Authorization: string, idCondominium: number, idUserWorker: number, body: SendEmailWorkerUserRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/userWorker/${idUserWorker}/sendEmail`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method workerRegister
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del usuario de obra
  * @return The full HTTP response as Observable
  */
  public workerRegister(Authorization: string, idCondominium: number, body: SearchWorkerRegisterRequest): Observable<HttpResponse<AllWorkerRegisterResponse>> {
    let uri = `/condominium/${idCondominium}/workerregister`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllWorkerRegisterResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method workerRegisterMovement
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idWorkerRegister The ID del registro de trabajador
  * @return The full HTTP response as Observable
  */
  public workerRegisterMovement(Authorization: string, idCondominium: number, idWorkerRegister: number): Observable<HttpResponse<AllWorkerRegisterMovementResponse>> {
    let uri = `/condominium/${idCondominium}/workerregistermovement/${idWorkerRegister}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllWorkerRegisterMovementResponse>('get', uri, headers, params, null);
  }

  /**
  * Method workerTypeProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public workerTypeProject(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/workerTypeProject`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createWorkerTypeProject
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del tipo de proyecto
  * @return The full HTTP response as Observable
  */
  public createWorkerTypeProject(Authorization: string, idCondominium: number, body: CreateWorkerTypeProjectRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/workerTypeProject`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateWorkerTypeProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del tipo de proyecto a editar
  * @return The full HTTP response as Observable
  */
  public updateWorkerTypeProject(Authorization: string, idCondominium: number, body: UpdateWorkerTypeProjectRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/workerTypeProject`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteWorkerTypeProject
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del tipo de proyecto
  * @return The full HTTP response as Observable
  */
  public deleteWorkerTypeProject(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/workerTypeProject/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method getWorkerUsersByType
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param userType The Tipo de trabajador a consultar
  * @return The full HTTP response as Observable
  */
  public getWorkerUsersByType(Authorization: string, idCondominium: number, userType: string): Observable<HttpResponse<AllWorkerUserByTypeResponse>> {
    let uri = `/condominium/${idCondominium}/catalog/getWorkerUsersByType/${userType}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllWorkerUserByTypeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method finger
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idResident The Id del residente de las huellas
  * @return The full HTTP response as Observable
  */
  public finger(Authorization: string, idCondominium: number, idResident: number): Observable<HttpResponse<AllFingerResponse>> {
    let uri = `/condominium/${idCondominium}/finger/${idResident}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllFingerResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createFinger
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del carro
  * @return The full HTTP response as Observable
  */
  public createFinger(Authorization: string, idCondominium: number, body: CreateFingerRequest): Observable<HttpResponse<FingerResponse>> {
    let uri = `/condominium/${idCondominium}/finger`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<FingerResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteFinger
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The Id de la huella
  * @return The full HTTP response as Observable
  */
  public deleteFinger(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/finger/delete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method commonAreaRestricted
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date The fecha a partir de la cual se tomaran los bloqueos
  * @param idHouse The casa
  * @return The full HTTP response as Observable
  */
  public commonAreaRestricted(Authorization: string, idCondominium: number, date: string, idHouse: number): Observable<HttpResponse<AllCommonAreaRestrictedResponse>> {
    let uri = `/condominium/${idCondominium}/commonarearestricted/${date}/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaRestrictedResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCommonAreaRestricted
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del carro
  * @return The full HTTP response as Observable
  */
  public createCommonAreaRestricted(Authorization: string, idCondominium: number, body: CreateCommonAreaRestrictedRequest): Observable<HttpResponse<CreateUpdateCommonAreaRestrictedResponse>> {
    let uri = `/condominium/${idCondominium}/commonarearestricted`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCommonAreaRestrictedResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateCommonAreaRestricted
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de carro a editar
  * @return The full HTTP response as Observable
  */
  public updateCommonAreaRestricted(Authorization: string, idCondominium: number, body: UpdateCommonAreaRestrictedRequest): Observable<HttpResponse<CreateUpdateCommonAreaRestrictedResponse>> {
    let uri = `/condominium/${idCondominium}/commonarearestricted`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCommonAreaRestrictedResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCommonAreaRestricted
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del bloqueo
  * @return The full HTTP response as Observable
  */
  public deleteCommonAreaRestricted(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/commonarearestricted/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method pet
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public pet(Authorization: string, idCondominium: number): Observable<HttpResponse<AllPetResponse>> {
    let uri = `/condominium/${idCondominium}/pet`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPetResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createPet
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la mascota
  * @return The full HTTP response as Observable
  */
  public createPet(Authorization: string, idCondominium: number, body: CreatePetRequest): Observable<HttpResponse<CreateUpdatePetResponse>> {
    let uri = `/condominium/${idCondominium}/pet`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdatePetResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updatePet
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la mascota
  * @return The full HTTP response as Observable
  */
  public updatePet(Authorization: string, idCondominium: number, body: UpdatePetRequest): Observable<HttpResponse<CreateUpdatePetResponse>> {
    let uri = `/condominium/${idCondominium}/pet`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdatePetResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deletePet
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de la mascota
  * @return The full HTTP response as Observable
  */
  public deletePet(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/pet/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method petPhoto
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de la mascota
  * @return The full HTTP response as Observable
  */
  public petPhoto(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/pet/image/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method petSearch
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la busqueda de la mascota
  * @return The full HTTP response as Observable
  */
  public petSearch(Authorization: string, idCondominium: number, body: PetSearchRequest): Observable<HttpResponse<AllPetSearchResponse>> {
    let uri = `/condominium/${idCondominium}/pet/search`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPetSearchResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method petDetail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de la mascota
  * @return The full HTTP response as Observable
  */
  public petDetail(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<PetDetailResponse>> {
    let uri = `/condominium/${idCondominium}/pet/detail/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PetDetailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method recurringcharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public recurringcharge(Authorization: string, idCondominium: number): Observable<HttpResponse<AllRecurringChargesResponse>> {
    let uri = `/condominium/${idCondominium}/recurringcharges`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllRecurringChargesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createRecurringCharges
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del cargo recurrente
  * @return The full HTTP response as Observable
  */
  public createRecurringCharges(Authorization: string, idCondominium: number, body: CreateRecurringChargesRequest): Observable<HttpResponse<CreateUpdateRecurringChargesResponse>> {
    let uri = `/condominium/${idCondominium}/recurringcharges`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateRecurringChargesResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateRecurringCharges
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de cargo recurrente
  * @return The full HTTP response as Observable
  */
  public updateRecurringCharges(Authorization: string, idCondominium: number, body: UpdateRecurringChargesRequest): Observable<HttpResponse<CreateUpdateRecurringChargesResponse>> {
    let uri = `/condominium/${idCondominium}/recurringcharges`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateRecurringChargesResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteRecurringCharges
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de cargo recurrente
  * @return The full HTTP response as Observable
  */
  public deleteRecurringCharges(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/recurringcharges/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method downloadExcelRecurringCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idListHouse The ID de la lista de la casa
  * @return The full HTTP response as Observable
  */
  public downloadExcelRecurringCharge(Authorization: string, idCondominium: number, idListHouse: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/recurringcharges/downloadexcel/${idListHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method recurringchargedates
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idRecurringCharges The ID del condominio
  * @return The full HTTP response as Observable
  */
  public recurringchargedates(Authorization: string, idCondominium: number, idRecurringCharges: number): Observable<HttpResponse<AllRecurringChargesDatesResponse>> {
    let uri = `/condominium/${idCondominium}/recurringchargesdates/${idRecurringCharges}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllRecurringChargesDatesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method recurringchargehouses
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idRecurringCharges The ID del condominio
  * @return The full HTTP response as Observable
  */
  public recurringchargehouses(Authorization: string, idCondominium: number, idRecurringCharges: number): Observable<HttpResponse<AllRecurringChargesHousesResponse>> {
    let uri = `/condominium/${idCondominium}/recurringchargeshouses/${idRecurringCharges}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllRecurringChargesHousesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method addHouseRecurringCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos dela casa
  * @return The full HTTP response as Observable
  */
  public addHouseRecurringCharge(Authorization: string, idCondominium: number, body: AddHouseRecurringChargesRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/recurringcharges/house`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteHouseRecurringCharges
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de la casa
  * @return The full HTTP response as Observable
  */
  public deleteHouseRecurringCharges(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/recurringcharges/house/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method rolApp
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public rolApp(Authorization: string, idCondominium: number): Observable<HttpResponse<AllRolAppResponse>> {
    let uri = `/condominium/${idCondominium}/rolapp`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllRolAppResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createRolApp
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del carro
  * @return The full HTTP response as Observable
  */
  public createRolApp(Authorization: string, idCondominium: number, body: CreateRolAppRequest): Observable<HttpResponse<CreateUpdateRolAppResponse>> {
    let uri = `/condominium/${idCondominium}/rolapp`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateRolAppResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateRolApp
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de rol a editar
  * @return The full HTTP response as Observable
  */
  public updateRolApp(Authorization: string, idCondominium: number, body: UpdateRolAppRequest): Observable<HttpResponse<CreateUpdateRolAppResponse>> {
    let uri = `/condominium/${idCondominium}/rolapp`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateRolAppResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteRolApp
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de rol
  * @return The full HTTP response as Observable
  */
  public deleteRolApp(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/rolapp/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method addDeleteActionRolApp
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idRolApp The ID del rol app
  * @param code The code de la acción
  * @param add The add en 1, delete en 0
  * @return The full HTTP response as Observable
  */
  public addDeleteActionRolApp(Authorization: string, idCondominium: number, idRolApp: number, code: number, add: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/rolappaction/${idRolApp}/${code}/${add}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method rolappactions
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idRolApp The ID del rol app
  * @return The full HTTP response as Observable
  */
  public rolappactions(Authorization: string, idCondominium: number, idRolApp: number): Observable<HttpResponse<CodeActionsResponse>> {
    let uri = `/condominium/${idCondominium}/rolappaction/${idRolApp}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CodeActionsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method documentCategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public documentCategory(Authorization: string, idCondominium: number): Observable<HttpResponse<AllDocumentCategoryResponse>> {
    let uri = `/condominium/${idCondominium}/documentcategory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDocumentCategoryResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createDocumentCategory
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la categoría
  * @return The full HTTP response as Observable
  */
  public createDocumentCategory(Authorization: string, idCondominium: number, body: CreateDocumentCategoryRequest): Observable<HttpResponse<CreateUpdateDocumentCategoryResponse>> {
    let uri = `/condominium/${idCondominium}/documentcategory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateDocumentCategoryResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateDocumentCategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la categoría a editar
  * @return The full HTTP response as Observable
  */
  public updateDocumentCategory(Authorization: string, idCondominium: number, body: UpdateDocumentCategoryRequest): Observable<HttpResponse<CreateUpdateDocumentCategoryResponse>> {
    let uri = `/condominium/${idCondominium}/documentcategory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateDocumentCategoryResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteDocumentCategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de la categoría
  * @return The full HTTP response as Observable
  */
  public deleteDocumentCategory(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/documentcategory/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method document
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public document(Authorization: string, idCondominium: number): Observable<HttpResponse<AllDocumentResponse>> {
    let uri = `/condominium/${idCondominium}/document`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDocumentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createDocument
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del documento
  * @return The full HTTP response as Observable
  */
  public createDocument(Authorization: string, idCondominium: number, body: CreateDocumentRequest): Observable<HttpResponse<CreateUpdateDocumentResponse>> {
    let uri = `/condominium/${idCondominium}/document`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateDocumentResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateDocument
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del documento
  * @return The full HTTP response as Observable
  */
  public updateDocument(Authorization: string, idCondominium: number, body: UpdateDocumentRequest): Observable<HttpResponse<CreateUpdateDocumentResponse>> {
    let uri = `/condominium/${idCondominium}/document`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateDocumentResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteDocument
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del documento
  * @return The full HTTP response as Observable
  */
  public deleteDocument(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/document/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method documentbycategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCategory The ID del condominio
  * @return The full HTTP response as Observable
  */
  public documentbycategory(Authorization: string, idCondominium: number, idCategory: number): Observable<HttpResponse<AllDocumentResponse>> {
    let uri = `/condominium/${idCondominium}/documentbycategory/${idCategory}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDocumentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method documentUrlS3
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idDocument The ID del condominio
  * @return The full HTTP response as Observable
  */
  public documentUrlS3(Authorization: string, idCondominium: number, idDocument: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/documenturls3/${idDocument}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method service
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public service(Authorization: string, idCondominium: number): Observable<HttpResponse<AllServiceResponse>> {
    let uri = `/condominium/${idCondominium}/service`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllServiceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createService
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del servicio
  * @return The full HTTP response as Observable
  */
  public createService(Authorization: string, idCondominium: number, body: CreateServiceRequest): Observable<HttpResponse<CreateUpdateServiceResponse>> {
    let uri = `/condominium/${idCondominium}/service`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateService
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de carro a editar
  * @return The full HTTP response as Observable
  */
  public updateService(Authorization: string, idCondominium: number, body: UpdateServiceRequest): Observable<HttpResponse<CreateUpdateServiceResponse>> {
    let uri = `/condominium/${idCondominium}/service`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteService
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de carro
  * @return The full HTTP response as Observable
  */
  public deleteService(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/service/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method servicetariff
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idService The ID del servicio
  * @return The full HTTP response as Observable
  */
  public servicetariff(Authorization: string, idCondominium: number, idService: number): Observable<HttpResponse<AllServiceTariffResponse>> {
    let uri = `/condominium/${idCondominium}/${idService}/servicetariff`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllServiceTariffResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createServiceTariff
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idService The ID del servicio
  * @param body The Datos del servicio
  * @return The full HTTP response as Observable
  */
  public createServiceTariff(Authorization: string, idCondominium: number, idService: number, body: CreateServiceTariffRequest): Observable<HttpResponse<CreateUpdateServiceTariffResponse>> {
    let uri = `/condominium/${idCondominium}/${idService}/servicetariff`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceTariffResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateServiceTariff
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idService The ID del servicio
  * @param body The Datos de carro a editar
  * @return The full HTTP response as Observable
  */
  public updateServiceTariff(Authorization: string, idCondominium: number, idService: number, body: UpdateServiceTariffRequest): Observable<HttpResponse<CreateUpdateServiceTariffResponse>> {
    let uri = `/condominium/${idCondominium}/${idService}/servicetariff`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceTariffResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteServiceTariff
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idService The ID del servicio
  * @param id The ID de carro
  * @return The full HTTP response as Observable
  */
  public deleteServiceTariff(Authorization: string, idCondominium: number, idService: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/${idService}/servicetariff/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method payouts
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public payouts(Authorization: string, idCondominium: number): Observable<HttpResponse<AllPayoutsResponse>> {
    let uri = `/condominium/${idCondominium}/payouts`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPayoutsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method payoutsdetails
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPayout The ID del payout
  * @return The full HTTP response as Observable
  */
  public payoutsdetails(Authorization: string, idCondominium: number, idPayout: number): Observable<HttpResponse<AllPayoutsDetailsResponse>> {
    let uri = `/condominium/${idCondominium}/payouts/details/${idPayout}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPayoutsDetailsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method payoutsdetailsExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idPayout The ID del payout
  * @return The full HTTP response as Observable
  */
  public payoutsdetailsExcel(Authorization: string, idCondominium: number, idPayout: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/payouts/details/excel/${idPayout}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method requestpayouts
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de mes y año
  * @return The full HTTP response as Observable
  */
  public requestpayouts(Authorization: string, idCondominium: number, body: RequestPayoutsRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/payouts/request`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method tariff
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public tariff(Authorization: string, idCondominium: number): Observable<HttpResponse<AllTariffResponse>> {
    let uri = `/condominium/${idCondominium}/tariff`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllTariffResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateTariff
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de carro a editar
  * @return The full HTTP response as Observable
  */
  public updateTariff(Authorization: string, idCondominium: number, body: UpdateTariffRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/tariff`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method tariffhouses
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idTarifChanges The ID de la tarifa cambiada
  * @return The full HTTP response as Observable
  */
  public tariffhouses(Authorization: string, idCondominium: number, idTarifChanges: number): Observable<HttpResponse<AllTariffHousesResponse>> {
    let uri = `/condominium/${idCondominium}/tariff/${idTarifChanges}/tariffhouses`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllTariffHousesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method downloadExcelTariff
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idListHouse The ID de la lista de casas, puede ir en 0
  * @return The full HTTP response as Observable
  */
  public downloadExcelTariff(Authorization: string, idCondominium: number, idListHouse: number): Observable<HttpResponse<ExcelResponse>> {
    let uri = `/condominium/${idCondominium}/tariff/${idListHouse}/downloadexcel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelResponse>('get', uri, headers, params, null);
  }

  /**
  * Method loadExcelTariff
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de casas a editar
  * @return The full HTTP response as Observable
  */
  public loadExcelTariff(Authorization: string, idCondominium: number, body: ExcelTariffRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/tariff/loadexcel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method adjustercharger
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de casas a editar
  * @return The full HTTP response as Observable
  */
  public adjustercharger(Authorization: string, idCondominium: number, body: AdjusterChargerRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/tariff/adjustercharger`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method adjustment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public adjustment(Authorization: string, idCondominium: number): Observable<HttpResponse<AllAdjustmentResponse>> {
    let uri = `/condominium/${idCondominium}/tariff/adjustment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllAdjustmentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method adjustmentcharges
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idAdjustmentAmount The ID del ajuste
  * @return The full HTTP response as Observable
  */
  public adjustmentcharges(Authorization: string, idCondominium: number, idAdjustmentAmount: number): Observable<HttpResponse<AllAdjustmentChargesResponse>> {
    let uri = `/condominium/${idCondominium}/tariff/${idAdjustmentAmount}/adjustmentcharges`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllAdjustmentChargesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method servicemeter
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idService The ID del servicio
  * @param idHouse The ID del servicio
  * @return The full HTTP response as Observable
  */
  public servicemeter(Authorization: string, idCondominium: number, idService: number, idHouse: number): Observable<HttpResponse<AllServiceMeterResponse>> {
    let uri = `/condominium/${idCondominium}/${idService}/${idHouse}/servicemeter`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllServiceMeterResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createServiceMeter
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idService The ID del servicio
  * @param idHouse The ID del servicio
  * @param body The Datos del servicio
  * @return The full HTTP response as Observable
  */
  public createServiceMeter(Authorization: string, idCondominium: number, idService: number, idHouse: number, body: CreateServiceMeterRequest): Observable<HttpResponse<CreateUpdateServiceMeterResponse>> {
    let uri = `/condominium/${idCondominium}/${idService}/${idHouse}/servicemeter`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceMeterResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateServiceMeter
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idService The ID del servicio
  * @param idHouse The ID del servicio
  * @param body The Datos de medidor a editar
  * @return The full HTTP response as Observable
  */
  public updateServiceMeter(Authorization: string, idCondominium: number, idService: number, idHouse: number, body: UpdateServiceMeterRequest): Observable<HttpResponse<CreateUpdateServiceMeterResponse>> {
    let uri = `/condominium/${idCondominium}/${idService}/${idHouse}/servicemeter`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceMeterResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteServiceMeter
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idService The ID del servicio
  * @param idHouse The ID del servicio
  * @param id The ID de medidor
  * @return The full HTTP response as Observable
  */
  public deleteServiceMeter(Authorization: string, idCondominium: number, idService: number, idHouse: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/${idService}/${idHouse}/servicemeter/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method servicecharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public servicecharge(Authorization: string, idCondominium: number): Observable<HttpResponse<AllServiceChargeResponse>> {
    let uri = `/condominium/${idCondominium}/servicecharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllServiceChargeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createServiceCharge
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del cargo de servicio
  * @return The full HTTP response as Observable
  */
  public createServiceCharge(Authorization: string, idCondominium: number, body: CreateServiceChargeRequest): Observable<HttpResponse<CreateUpdateServiceChargeResponse>> {
    let uri = `/condominium/${idCondominium}/servicecharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceChargeResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateServiceCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del cargo de servicio
  * @return The full HTTP response as Observable
  */
  public updateServiceCharge(Authorization: string, idCondominium: number, body: UpdateServiceChargeRequest): Observable<HttpResponse<CreateUpdateServiceChargeResponse>> {
    let uri = `/condominium/${idCondominium}/servicecharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceChargeResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteServiceCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del cargo de servicio
  * @return The full HTTP response as Observable
  */
  public deleteServiceCharge(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/servicecharge/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method servicechargeexcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idService The ID del cargo del servicio
  * @param idListHouse The ID del listado de casa
  * @param defaultPrice The precio por defecto
  * @return The full HTTP response as Observable
  */
  public servicechargeexcel(Authorization: string, idCondominium: number, idService: number, idListHouse: number, defaultPrice: number): Observable<HttpResponse<ExcelResponse>> {
    let uri = `/condominium/${idCondominium}/servicechargeexcel/${idService}/${idListHouse}/${defaultPrice}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelResponse>('get', uri, headers, params, null);
  }

  /**
  * Method applyservicecharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del cargo de servicio
  * @return The full HTTP response as Observable
  */
  public applyservicecharge(Authorization: string, idCondominium: number, body: ApplyServiceChargeRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/applyservicecharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method contpaqdiarypolicy
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idServiceCharge The ID del Service Charge
  * @param date The datos del filtrado
  * @param policy The Número de poliza contable
  * @return The full HTTP response as Observable
  */
  public contpaqdiarypolicy(Authorization: string, idCondominium: number, idServiceCharge: number, date: string, policy: number): Observable<HttpResponse<ContpaqIncomePolicyResponse>> {
    let uri = `/condominium/${idCondominium}/servicecharge/${idServiceCharge}/contpaqdiarypolicy/${date}/${policy}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ContpaqIncomePolicyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updatelatersaveservicecharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del cargo de servicio
  * @return The full HTTP response as Observable
  */
  public updatelatersaveservicecharge(Authorization: string, idCondominium: number, body: UpdateLaterSaveServiceChargeRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/editlatersaveservicecharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method servicechargehouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param idService The ID del servicio
  * @return The full HTTP response as Observable
  */
  public servicechargehouse(Authorization: string, idCondominium: number, idHouse: number, idService: number): Observable<HttpResponse<AllServiceChargeHouseResponse>> {
    let uri = `/condominium/${idCondominium}/servicechargehouse/${idHouse}/${idService}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllServiceChargeHouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method servicechargehouseExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param idService The ID del servicio
  * @return The full HTTP response as Observable
  */
  public servicechargehouseExcel(Authorization: string, idCondominium: number, idHouse: number, idService: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/servicechargehouse/excel/${idHouse}/${idService}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateServiceChargeHouse
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del cargo de servicio de casa
  * @return The full HTTP response as Observable
  */
  public updateServiceChargeHouse(Authorization: string, idCondominium: number, body: CreateServiceChargeHouseRequest): Observable<HttpResponse<CreateUpdateServiceChargeHouseResponse>> {
    let uri = `/condominium/${idCondominium}/servicechargehouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateServiceChargeHouseResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method unrecognizedpayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public unrecognizedpayment(Authorization: string, idCondominium: number): Observable<HttpResponse<AllUnrecognizedPaymentResponse>> {
    let uri = `/condominium/${idCondominium}/unrecognizedpayment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllUnrecognizedPaymentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createUnrecognizedPayment
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del servicio
  * @return The full HTTP response as Observable
  */
  public createUnrecognizedPayment(Authorization: string, idCondominium: number, body: CreateUnrecognizedPaymentRequest): Observable<HttpResponse<CreateUpdateUnrecognizedPaymentResponse>> {
    let uri = `/condominium/${idCondominium}/unrecognizedpayment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateUnrecognizedPaymentResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateUnrecognizedPayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del pago no reconocid
  * @return The full HTTP response as Observable
  */
  public updateUnrecognizedPayment(Authorization: string, idCondominium: number, body: UpdateUnrecognizedPaymentRequest): Observable<HttpResponse<CreateUpdateUnrecognizedPaymentResponse>> {
    let uri = `/condominium/${idCondominium}/unrecognizedpayment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateUnrecognizedPaymentResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteUnrecognizedPayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de pago no reconocido
  * @return The full HTTP response as Observable
  */
  public deleteUnrecognizedPayment(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/unrecognizedpayment/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method unrecognizedpaymentExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public unrecognizedpaymentExcel(Authorization: string, idCondominium: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/unrecognizedpayment/excel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method extraordinarycharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public extraordinarycharge(Authorization: string, idCondominium: number): Observable<HttpResponse<AllExtraordinaryChargeResponse>> {
    let uri = `/condominium/${idCondominium}/extraordinarycharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllExtraordinaryChargeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createExtraordinarycharge
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la cuenta a registrar
  * @return The full HTTP response as Observable
  */
  public createExtraordinarycharge(Authorization: string, idCondominium: number, body: CreateExtraordinaryChargeRequest): Observable<HttpResponse<CreateUpdateExtraordinaryChargeResponse>> {
    let uri = `/condominium/${idCondominium}/extraordinarycharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateExtraordinaryChargeResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateExtraordinaryCharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de cargo extraordinario a modificar
  * @return The full HTTP response as Observable
  */
  public updateExtraordinaryCharge(Authorization: string, idCondominium: number, body: UpdateExtraordinaryChargeRequest): Observable<HttpResponse<CreateUpdateExtraordinaryChargeResponse>> {
    let uri = `/condominium/${idCondominium}/extraordinarycharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateExtraordinaryChargeResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteExtraordinarycharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idExtraordinaryCharge The ID de cargo extraordinario
  * @return The full HTTP response as Observable
  */
  public deleteExtraordinarycharge(Authorization: string, idCondominium: number, idExtraordinaryCharge: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/extraordinarycharge/${idExtraordinaryCharge}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method excelextraordinarycharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idList The ID de la lista de casas
  * @param description The Descripción del cargo
  * @return The full HTTP response as Observable
  */
  public excelextraordinarycharge(Authorization: string, idCondominium: number, idList: number, description: string): Observable<HttpResponse<ExcelExtraordinaryChargeResponse>> {
    let uri = `/condominium/${idCondominium}/excelextraordinarycharge/${idList}/${description}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelExtraordinaryChargeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method extraordinarychargebyid
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idExtraordinaryCharge The ID del cargo extraordinario
  * @return The full HTTP response as Observable
  */
  public extraordinarychargebyid(Authorization: string, idCondominium: number, idExtraordinaryCharge: number): Observable<HttpResponse<OneExtraordinaryChargeResponse>> {
    let uri = `/condominium/${idCondominium}/extraordinarychargebyid/${idExtraordinaryCharge}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<OneExtraordinaryChargeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method extraordinarychargehouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idExtraordinaryCharge The ID del cargo extraordinario
  * @return The full HTTP response as Observable
  */
  public extraordinarychargehouse(Authorization: string, idCondominium: number, idExtraordinaryCharge: number): Observable<HttpResponse<AllExtraordinaryChargeHouseResponse>> {
    let uri = `/condominium/${idCondominium}/extraordinarychargehouse/${idExtraordinaryCharge}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllExtraordinaryChargeHouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateExtraordinaryChargeDates
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de cargo extraordinario a modificar
  * @return The full HTTP response as Observable
  */
  public updateExtraordinaryChargeDates(Authorization: string, idCondominium: number, body: UpdateExtraordinaryChargeDatesRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/extraordinarychargedates`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method housecombobox
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public housecombobox(Authorization: string, idCondominium: number): Observable<HttpResponse<AllHouseComboboxResponse>> {
    let uri = `/condominium/${idCondominium}/housecombobox`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHouseComboboxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housecomboboxbyresident
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idResident The ID del residente
  * @return The full HTTP response as Observable
  */
  public housecomboboxbyresident(Authorization: string, idCondominium: number, idResident: number): Observable<HttpResponse<AllHouseComboboxResponse>> {
    let uri = `/condominium/${idCondominium}/housecombobox/${idResident}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHouseComboboxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method residentcombobox
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public residentcombobox(Authorization: string, idCondominium: number): Observable<HttpResponse<AllResidentComboboxResponse>> {
    let uri = `/condominium/${idCondominium}/residentcombobox`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllResidentComboboxResponse>('get', uri, headers, params, null);
  }

  /**
  * Method autocompleteclavesat
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param cad The cadena de busqueda
  * @return The full HTTP response as Observable
  */
  public autocompleteclavesat(Authorization: string, idCondominium: number, cad: string): Observable<HttpResponse<AllMapKeyResponse>> {
    let uri = `/condominium/${idCondominium}/common/clavesat/${cad}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapKeyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method autocompleteunidadsat
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param cad The cadena de busqueda
  * @return The full HTTP response as Observable
  */
  public autocompleteunidadsat(Authorization: string, idCondominium: number, cad: string): Observable<HttpResponse<AllMapKeyResponse>> {
    let uri = `/condominium/${idCondominium}/common/unidadsat/${cad}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapKeyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method usoCfdi
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public usoCfdi(Authorization: string): Observable<HttpResponse<AllUsoCFDIResponse>> {
    let uri = `/condominium/common/usocfdi`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllUsoCFDIResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housedebt
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public housedebt(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<NumberResponse>> {
    let uri = `/condominium/${idCondominium}/common/housedebt/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NumberResponse>('get', uri, headers, params, null);
  }

  /**
  * Method unpaidcharges
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public unpaidcharges(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllUnpaidChargesResponse>> {
    let uri = `/condominium/${idCondominium}/common/unpaidcharges/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllUnpaidChargesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housedebtchargeandrecharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The id de la casa
  * @param idConceptGroup The id del grupo de concepto
  * @param idConcept The id del concepto
  * @param month The mes a partir de cual sacar el saldo
  * @param year The año a partir de cual sacar el saldo
  * @return The full HTTP response as Observable
  */
  public housedebtchargeandrecharge(Authorization: string, idCondominium: number, idHouse: number, idConceptGroup: number, idConcept: number, month: number, year: number): Observable<HttpResponse<AllDebtHouseResponse>> {
    let uri = `/condominium/${idCondominium}/common/housedebtchargeandrecharge/${idHouse}/${idConceptGroup}/${idConcept}/${month}/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDebtHouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method emailsbyhouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The id de la casa
  * @return The full HTTP response as Observable
  */
  public emailsbyhouse(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/emailsbyhouse/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method regimenesfiscales
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public regimenesfiscales(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/regimenfiscal`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method residentanduserbyhouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The id de la casa
  * @return The full HTTP response as Observable
  */
  public residentanduserbyhouse(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/residentanduserbyhouse/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method residentidbyhouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The id de la casa
  * @return The full HTTP response as Observable
  */
  public residentidbyhouse(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/residentidbyhouse/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method cboconceptcategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idTypeConceptMode The id del tipo de concepto
  * @return The full HTTP response as Observable
  */
  public cboconceptcategory(Authorization: string, idCondominium: number, idTypeConceptMode: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/conceptcategory/${idTypeConceptMode}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method conceptwithcategory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idTypeConceptMode The id del tipo de concepto
  * @param type The tipo concepto o recargo
  * @return The full HTTP response as Observable
  */
  public conceptwithcategory(Authorization: string, idCondominium: number, idTypeConceptMode: number, type: number): Observable<HttpResponse<AllConceptWithCategoryResponse>> {
    let uri = `/condominium/${idCondominium}/common/conceptwithcategory/${idTypeConceptMode}/${type}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllConceptWithCategoryResponse>('get', uri, headers, params, null);
  }

  /**
  * Method color
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public color(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/color`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method commonAreaToCourse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public commonAreaToCourse(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/commonareatocourse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method commonCourseInstructor
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public commonCourseInstructor(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/courseinstructor`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method commonGetActiveCourses
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public commonGetActiveCourses(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/getactivecourses`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method incidenceAreas
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public incidenceAreas(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/incidenceareas`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method incidenceTypes
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idArea The ID del área
  * @return The full HTTP response as Observable
  */
  public incidenceTypes(Authorization: string, idCondominium: number, idArea: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/incidencetypes/${idArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method panelgroup
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public panelgroup(Authorization: string, idCondominium: number): Observable<HttpResponse<AllPanelGroupResponse>> {
    let uri = `/condominium/${idCondominium}/common/panelgroup`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllPanelGroupResponse>('get', uri, headers, params, null);
  }

  /**
  * Method petColors
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public petColors(Authorization: string, idCondominium: number): Observable<HttpResponse<AllStringResponse>> {
    let uri = `/condominium/${idCondominium}/common/petcolors`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllStringResponse>('get', uri, headers, params, null);
  }

  /**
  * Method petRace
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public petRace(Authorization: string, idCondominium: number): Observable<HttpResponse<AllStringResponse>> {
    let uri = `/condominium/${idCondominium}/common/petrace`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllStringResponse>('get', uri, headers, params, null);
  }

  /**
  * Method species
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public species(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/species`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method series
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public series(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/series`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method conceptgroups
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param optionPositiveBalance The 0 = todos los grupos, 1 = positivo, 2 = negativo
  * @return The full HTTP response as Observable
  */
  public conceptgroups(Authorization: string, idCondominium: number, optionPositiveBalance: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/conceptgroups/${optionPositiveBalance}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method counthouses
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public counthouses(Authorization: string, idCondominium: number): Observable<HttpResponse<NumberResponse>> {
    let uri = `/condominium/${idCondominium}/common/counthouses`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NumberResponse>('get', uri, headers, params, null);
  }

  /**
  * Method useradminincidenceresponsible
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idIncidence The ID de la incidencia, el tipo se analiza en el endpoint
  * @return The full HTTP response as Observable
  */
  public useradminincidenceresponsible(Authorization: string, idCondominium: number, idIncidence: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/useradminincidenceresponsible/${idIncidence}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method useradminincidenceresponsibleall
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public useradminincidenceresponsibleall(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/useradminincidenceresponsibleall`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method useradminwithassignmentincidence
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public useradminwithassignmentincidence(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/useradminwithassignmentincidence`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method actionsapp
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public actionsapp(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/actionsapp`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method modulesapp
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public modulesapp(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/modulesapp`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method carcbo
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public carcbo(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/car/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method activeAccount
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public activeAccount(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/accountactive`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method typeAccessevent
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public typeAccessevent(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/accessevent`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method invoicewithoutpaymentbyhouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param total The Total de la factura
  * @return The full HTTP response as Observable
  */
  public invoicewithoutpaymentbyhouse(Authorization: string, idCondominium: number, idHouse: number, total: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/invoicewithoutpaymentbyhouse/${idHouse}/${total}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method commonareagroup
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public commonareagroup(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/commonareagroup`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method fiscalinfocbo
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public fiscalinfocbo(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllMapFlagResponse>> {
    let uri = `/condominium/${idCondominium}/common/fiscalinfo/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapFlagResponse>('get', uri, headers, params, null);
  }

  /**
  * Method accesspanel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public accesspanel(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/accesspanel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method accesstemplate
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idAccessPanel The ID del panel de acceso
  * @return The full HTTP response as Observable
  */
  public accesstemplate(Authorization: string, idCondominium: number, idAccessPanel: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/accesstemplate/${idAccessPanel}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method accessdoor
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idAccessPanel The ID del panel de acceso
  * @return The full HTTP response as Observable
  */
  public accessdoor(Authorization: string, idCondominium: number, idAccessPanel: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/accessdoor/${idAccessPanel}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method accessgroup
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public accessgroup(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/accessgroup`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method typecar
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public typecar(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/typecar`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method estimatebyyear
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The año
  * @return The full HTTP response as Observable
  */
  public estimatebyyear(Authorization: string, idCondominium: number, year: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/estimate/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method unity
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public unity(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/unity`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method unrecognizedactivepayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public unrecognizedactivepayment(Authorization: string, idCondominium: number): Observable<HttpResponse<AllUnrecognizedActivePaymentResponse>> {
    let uri = `/condominium/${idCondominium}/common/unrecognizedactivepayment`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllUnrecognizedActivePaymentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method accesslevelhikvision
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public accesslevelhikvision(Authorization: string, idCondominium: number): Observable<HttpResponse<AllMapResponse>> {
    let uri = `/condominium/${idCondominium}/common/accesslevelhikvision`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllMapResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public housing(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllHousingResponse>> {
    let uri = `/condominium/${idCondominium}/housing/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHousingResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housingDetail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param id The Id del hospedaje
  * @return The full HTTP response as Observable
  */
  public housingDetail(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<HousingDetailResponse>> {
    let uri = `/condominium/${idCondominium}/housingdetail/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<HousingDetailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housingPDF
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param id The Id del hospedaje
  * @return The full HTTP response as Observable
  */
  public housingPDF(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/housingpdf/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housingIdentification
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param id The Id del housing
  * @return The full HTTP response as Observable
  */
  public housingIdentification(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/housingidentification/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housingGuestImage
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param id The Id del invitado
  * @return The full HTTP response as Observable
  */
  public housingGuestImage(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/housingguestimage/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method checkavailabledate
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param body The Fechas a validar
  * @return The full HTTP response as Observable
  */
  public checkavailabledate(Authorization: string, idCondominium: number, idHouse: number, body: CheckAvailableDateRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/housing/checkavailabledate/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method checkavailabledateInEdit
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param idHousing The Id de la casa
  * @param body The Fechas a validar
  * @return The full HTTP response as Observable
  */
  public checkavailabledateInEdit(Authorization: string, idCondominium: number, idHouse: number, idHousing: number, body: CheckAvailableDateRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/housing/checkavailabledateedit/${idHouse}/${idHousing}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method createHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Datos de la reservación
  * @return The full HTTP response as Observable
  */
  public createHousing(Authorization: string, idCondominium: number, body: HousingRequest): Observable<HttpResponse<CreateUpdateHousingResponse>> {
    let uri = `/condominium/${idCondominium}/housing`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateHousingResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Datos de la reservación
  * @return The full HTTP response as Observable
  */
  public updateHousing(Authorization: string, idCondominium: number, body: UpdateHousingRequest): Observable<HttpResponse<CreateUpdateHousingResponse>> {
    let uri = `/condominium/${idCondominium}/housing`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateHousingResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del hospedaje a eliminar
  * @return The full HTTP response as Observable
  */
  public deleteHousing(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/deletehousing/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method housingApprove
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param id The Id del hospedaje
  * @return The full HTTP response as Observable
  */
  public housingApprove(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/approvehousing/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method housingDisapprove
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param id The Id del hospedaje
  * @return The full HTTP response as Observable
  */
  public housingDisapprove(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/disapprovehousing/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method housingCheckin
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param idStateCheckin The estado del checkin
  * @return The full HTTP response as Observable
  */
  public housingCheckin(Authorization: string, idCondominium: number, idHouse: number, idStateCheckin: number): Observable<HttpResponse<AllHousingResponse>> {
    let uri = `/condominium/${idCondominium}/housingcheckin/${idHouse}/${idStateCheckin}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHousingResponse>('get', uri, headers, params, null);
  }

  /**
  * Method checkinHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public checkinHousing(Authorization: string, idCondominium: number, body: HousingCheckinRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/checkinhousing`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editCheckinHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public editCheckinHousing(Authorization: string, idCondominium: number, body: EditHousingCheckinRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/housing/editcheckinhousing`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editGuests
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public editGuests(Authorization: string, idCondominium: number, body: EditGuestsRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/editguests`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editSubstitutes
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public editSubstitutes(Authorization: string, idCondominium: number, body: EditSubstitutesRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/editsubstitutes`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method checkoutHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public checkoutHousing(Authorization: string, idCondominium: number, body: HousingCheckoutRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/checkouthousing`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method checkoutSelectableHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public checkoutSelectableHousing(Authorization: string, idCondominium: number, body: HousingCheckoutSelectableRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/housing/checkoutselectablehousing`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method reportHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param date1 The fecha inicio
  * @param date2 The fecha fin
  * @return The full HTTP response as Observable
  */
  public reportHousing(Authorization: string, idCondominium: number, idHouse: number, date1: string, date2: string): Observable<HttpResponse<AllReportHousingResponse>> {
    let uri = `/condominium/${idCondominium}/reporthousing/${idHouse}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllReportHousingResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportHousingPDF
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param date1 The fecha inicio
  * @param date2 The fecha fin
  * @return The full HTTP response as Observable
  */
  public reportHousingPDF(Authorization: string, idCondominium: number, idHouse: number, date1: string, date2: string): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/reporthousingpdf/${idHouse}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method housingHistoricalReport
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idHouse The Id de la casa
  * @param date1 The fecha inicio
  * @param date2 The fecha fin
  * @param searchEntrance The Buscar por entrada
  * @return The full HTTP response as Observable
  */
  public housingHistoricalReport(Authorization: string, idCondominium: number, idHouse: number, date1: string, date2: string, searchEntrance: boolean): Observable<HttpResponse<AllHousingResponse>> {
    let uri = `/condominium/${idCondominium}/housinghistoricalreport/${idHouse}/${date1}/${date2}/${searchEntrance}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllHousingResponse>('get', uri, headers, params, null);
  }

  /**
  * Method editDateHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Archivos para el checkin
  * @return The full HTTP response as Observable
  */
  public editDateHousing(Authorization: string, idCondominium: number, body: EditDateHousingRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/housing/editdate`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method transferHousing
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Información de transferencia
  * @return The full HTTP response as Observable
  */
  public transferHousing(Authorization: string, idCondominium: number, body: TransferHousingRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/housing/transfer`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method reportHousingOcuppancyExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param date1 The fecha inicio
  * @param date2 The fecha fin
  * @return The full HTTP response as Observable
  */
  public reportHousingOcuppancyExcel(Authorization: string, idCondominium: number, idHouse: number, date1: string, date2: string): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/housing/reportoccupancyexcel/${idHouse}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportHousingQuantityOcuppancyExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param date The fecha inicio
  * @return The full HTTP response as Observable
  */
  public reportHousingQuantityOcuppancyExcel(Authorization: string, idCondominium: number, idHouse: number, date: string): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/housing/reportquantityoccupancyexcel/${idHouse}/${date}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createpartialpayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Datos del pago parcial
  * @return The full HTTP response as Observable
  */
  public createpartialpayment(Authorization: string, idCondominium: number, body: CreatePartialPaymentRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/partialpayments`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method condominiumFiscalData
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public condominiumFiscalData(Authorization: string, idCondominium: number): Observable<HttpResponse<AllCondominiumFiscalDataResponse>> {
    let uri = `/condominium/${idCondominium}/condominiumfiscaldata`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCondominiumFiscalDataResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateCondominiumFiscalData
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Datos del pago parcial
  * @return The full HTTP response as Observable
  */
  public updateCondominiumFiscalData(Authorization: string, idCondominium: number, body: UpdateCondominiumFiscalDataRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/condominiumfiscaldata`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method condominiumFileStatus
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public condominiumFileStatus(Authorization: string, idCondominium: number): Observable<HttpResponse<FileStatusResponse>> {
    let uri = `/condominium/${idCondominium}/condominiumfilestatus`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<FileStatusResponse>('get', uri, headers, params, null);
  }

  /**
  * Method uploadCondominiumFiscalFile
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Datos del pago parcial
  * @return The full HTTP response as Observable
  */
  public uploadCondominiumFiscalFile(Authorization: string, idCondominium: number, body: UploadFiscalFileRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/condominiumfiscaldata/uploadfile`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method uploadCondominiumFiscalLogo
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param body The Datos del pago parcial
  * @return The full HTTP response as Observable
  */
  public uploadCondominiumFiscalLogo(Authorization: string, idCondominium: number, body: UploadFiscalLogoRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/condominiumfiscaldata/uploadlogo`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method getCurrency
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public getCurrency(Authorization: string, idCondominium: number): Observable<HttpResponse<AllCurrencyResponse>> {
    let uri = `/condominium/${idCondominium}/currency`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCurrencyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCurrency
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la casa a registrar
  * @return The full HTTP response as Observable
  */
  public createCurrency(Authorization: string, idCondominium: number, body: CreateCurrencyRequest): Observable<HttpResponse<CreateUpdateCurrencyResponse>> {
    let uri = `/condominium/${idCondominium}/currency`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCurrencyResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateCurrency
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la casa a registrar
  * @return The full HTTP response as Observable
  */
  public updateCurrency(Authorization: string, idCondominium: number, body: UpdateCurrencyRequest): Observable<HttpResponse<CreateUpdateCurrencyResponse>> {
    let uri = `/condominium/${idCondominium}/currency`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCurrencyResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCurrency
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCurrency The ID de la divisa
  * @return The full HTTP response as Observable
  */
  public deleteCurrency(Authorization: string, idCondominium: number, idCurrency: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/currency/${idCurrency}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method residenthouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idResident The ID del residente de las casas
  * @return The full HTTP response as Observable
  */
  public residenthouse(Authorization: string, idCondominium: number, idResident: number): Observable<HttpResponse<AllResidentHouseResponse>> {
    let uri = `/condominium/${idCondominium}/${idResident}/residenthouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllResidentHouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createResidentHouse
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idResident The ID del residente de las casas
  * @param body The Datos de la casa a registrar
  * @return The full HTTP response as Observable
  */
  public createResidentHouse(Authorization: string, idCondominium: number, idResident: number, body: CreateResidentHouseRequest): Observable<HttpResponse<CreateResidentHouseResponse>> {
    let uri = `/condominium/${idCondominium}/${idResident}/residenthouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateResidentHouseResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method DeleteResidentHouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idResident The ID del residente casa
  * @return The full HTTP response as Observable
  */
  public DeleteResidentHouse(Authorization: string, idCondominium: number, idResident: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/residenthouse/${idResident}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method residenthousebyhouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public residenthousebyhouse(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AllResidentHouseResponse>> {
    let uri = `/condominium/${idCondominium}/${idHouse}/residenthousebyhouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllResidentHouseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createResidentHouseByHouse
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param body The Datos del residente a asignar
  * @return The full HTTP response as Observable
  */
  public createResidentHouseByHouse(Authorization: string, idCondominium: number, idHouse: number, body: CreateResidentHouseByHouseRequest): Observable<HttpResponse<CreateResidentHouseResponse>> {
    let uri = `/condominium/${idCondominium}/${idHouse}/residenthousebyhouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateResidentHouseResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateResidentHouseByHouse
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param body The Datos del residente a asignar
  * @return The full HTTP response as Observable
  */
  public updateResidentHouseByHouse(Authorization: string, idCondominium: number, idHouse: number, body: UpdateResidentHouseByHouseRequest): Observable<HttpResponse<CreateResidentHouseResponse>> {
    let uri = `/condominium/${idCondominium}/${idHouse}/residenthousebyhouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateResidentHouseResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method directory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public directory(Authorization: string, idCondominium: number): Observable<HttpResponse<AllDirectoryResponse>> {
    let uri = `/condominium/${idCondominium}/directory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllDirectoryResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createDirectory
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del contacto a registrar
  * @return The full HTTP response as Observable
  */
  public createDirectory(Authorization: string, idCondominium: number, body: CreateDirectoryRequest): Observable<HttpResponse<CreateUpdateDirectoryResponse>> {
    let uri = `/condominium/${idCondominium}/directory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateDirectoryResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateDirectory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del contacto a modificar
  * @return The full HTTP response as Observable
  */
  public updateDirectory(Authorization: string, idCondominium: number, body: UpdateDirectoryRequest): Observable<HttpResponse<CreateUpdateDirectoryResponse>> {
    let uri = `/condominium/${idCondominium}/directory`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateDirectoryResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteDirectory
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del contacto
  * @return The full HTTP response as Observable
  */
  public deleteDirectory(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/directory/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method commonarea
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public commonarea(Authorization: string, idCondominium: number): Observable<HttpResponse<AllCommonAreaResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCommonArea
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del contacto a registrar
  * @return The full HTTP response as Observable
  */
  public createCommonArea(Authorization: string, idCondominium: number, body: CreateCommonAreaRequest): Observable<HttpResponse<CreateUpdateCommonAreaResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCommonAreaResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateCommonArea
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del area común a modificar
  * @return The full HTTP response as Observable
  */
  public updateCommonArea(Authorization: string, idCondominium: number, body: UpdateCommonAreaRequest): Observable<HttpResponse<CreateUpdateCommonAreaResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateCommonAreaResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCommonArea
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del área común
  * @return The full HTTP response as Observable
  */
  public deleteCommonArea(Authorization: string, idCondominium: number, idCommonArea: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea/${idCommonArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method commonareaDaysMaintenance
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del área común
  * @return The full HTTP response as Observable
  */
  public commonareaDaysMaintenance(Authorization: string, idCondominium: number, idCommonArea: number): Observable<HttpResponse<AllCommonAreaDaysMaintenanceResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea/daysmaintenance/${idCommonArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaDaysMaintenanceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCommonAreaDayMaintenance
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del contacto a registrar
  * @return The full HTTP response as Observable
  */
  public createCommonAreaDayMaintenance(Authorization: string, idCondominium: number, body: CreateCommonAreaDayMaintenanceRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea/daysmaintenance`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCommonAreaDayMaintenance
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del área común
  * @return The full HTTP response as Observable
  */
  public deleteCommonAreaDayMaintenance(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea/daysmaintenance/delete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method commonareahours
  * @param Authorization The Frakcio Admin
  * @param idCommonArea The ID del area
  * @return The full HTTP response as Observable
  */
  public commonareahours(Authorization: string, idCommonArea: number): Observable<HttpResponse<AllCommonAreaHoursResponse>> {
    let uri = `/commonarea/${idCommonArea}/commonareahours`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaHoursResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createCommonAreaHour
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del area
  * @param body The Datos del contacto a registrar
  * @return The full HTTP response as Observable
  */
  public createCommonAreaHour(Authorization: string, idCondominium: number, idCommonArea: number, body: CreateCommonAreaHourRequest): Observable<HttpResponse<CreateCommonAreaHourResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea/${idCommonArea}/commonareahours`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateCommonAreaHourResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteCommonAreaHour
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del area
  * @param idCommonareahours The ID de la hora
  * @return The full HTTP response as Observable
  */
  public deleteCommonAreaHour(Authorization: string, idCondominium: number, idCommonArea: number, idCommonareahours: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/commonarea/${idCommonArea}/commonareahours/${idCommonareahours}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method commonareahouravailable
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idCommonArea The Id de la área común
  * @param date The fecha de la reservación
  * @param idCommonAreaHour The id del area común hora
  * @return The full HTTP response as Observable
  */
  public commonareahouravailable(Authorization: string, idCondominium: number, idCommonArea: number, date: string, idCommonAreaHour: number): Observable<HttpResponse<AllCommonAreaHourAvailableResponse>> {
    let uri = `/condominium/${idCondominium}/commonareahouravailable/${idCommonArea}/${date}/${idCommonAreaHour}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaHourAvailableResponse>('get', uri, headers, params, null);
  }

  /**
  * Method commonareablock
  * @param Authorization The Frakcio Admin
  * @param idCondominium The Id del condominio
  * @param idCommonArea The Id de la área común
  * @param date The fecha de la reservación
  * @param idHouse The Id de la casa
  * @return The full HTTP response as Observable
  */
  public commonareablock(Authorization: string, idCondominium: number, idCommonArea: number, date: string, idHouse: number): Observable<HttpResponse<AllCommonAreaBlockResponse>> {
    let uri = `/condominium/${idCondominium}/commonareablock/${idCommonArea}/${date}/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllCommonAreaBlockResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reservation
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del area comun
  * @return The full HTTP response as Observable
  */
  public reservation(Authorization: string, idCondominium: number, idCommonArea: number): Observable<HttpResponse<AllReservationResponse>> {
    let uri = `/condominium/${idCondominium}/reservation/${idCommonArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllReservationResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createReservation
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos de la reservación
  * @return The full HTTP response as Observable
  */
  public createReservation(Authorization: string, idCondominium: number, body: CreateReservationRequest): Observable<HttpResponse<CreateUpdateReservationResponse>> {
    let uri = `/condominium/${idCondominium}/reservation`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateReservationResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method createreservationblock
  * @param Authorization The Frakcio Admin
  * @param body The Datos de la reservación
  * @param idCondominium The Id del condominio
  * @return The full HTTP response as Observable
  */
  public createreservationblock(Authorization: string, body: ReservationBlockRequest, idCondominium: number): Observable<HttpResponse<CreateReservationResponse>> {
    let uri = `/condominium/${idCondominium}/reservationblock`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateReservationResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteReserve
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idReservation The ID de reservación
  * @return The full HTTP response as Observable
  */
  public deleteReserve(Authorization: string, idCondominium: number, idReservation: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/reservationdelete/${idReservation}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method excelreservation
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCommonArea The id del área común
  * @param date1 The fecha de filtrado
  * @param date2 The fecha de filtrado
  * @return The full HTTP response as Observable
  */
  public excelreservation(Authorization: string, idCondominium: number, idCommonArea: number, date1: string, date2: string): Observable<HttpResponse<ExcelReservationResponse>> {
    let uri = `/condominium/${idCondominium}/excelreservation/${idCommonArea}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelReservationResponse>('get', uri, headers, params, null);
  }

  /**
  * Method disabledcalendardays
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del area comun
  * @return The full HTTP response as Observable
  */
  public disabledcalendardays(Authorization: string, idCondominium: number, idCommonArea: number): Observable<HttpResponse<DisabledCalendarDaysResponse>> {
    let uri = `/condominium/${idCondominium}/disabledcalendardays/${idCommonArea}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DisabledCalendarDaysResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reservationavailability
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCommonArea The ID del area comun
  * @param idHouse The Id de la casa
  * @param date The fecha que se quiere reservar
  * @param idResident The Id del residente
  * @return The full HTTP response as Observable
  */
  public reservationavailability(Authorization: string, idCondominium: number, idCommonArea: number, idHouse: number, date: string, idResident: number): Observable<HttpResponse<ReservationAvailabilityResource>> {
    let uri = `/condominium/${idCondominium}/reservationavailability/${idCommonArea}/${idHouse}/${date}/${idResident}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ReservationAvailabilityResource>('get', uri, headers, params, null);
  }

  /**
  * Method invitation
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The ID del condominio
  * @param date2 The ID del condominio
  * @param idHouse The ID de la casa
  * @param idStatus The status de la invitación
  * @return The full HTTP response as Observable
  */
  public invitation(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, idStatus: number): Observable<HttpResponse<AllInvitationResponse>> {
    let uri = `/condominium/${idCondominium}/invitation/${date1}/${date2}/${idHouse}/${idStatus}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllInvitationResponse>('get', uri, headers, params, null);
  }

  /**
  * Method updateInvitation
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de la invitación a editar
  * @return The full HTTP response as Observable
  */
  public updateInvitation(Authorization: string, idCondominium: number, body: UpdateInvitationRequest): Observable<HttpResponse<CreateUpdateInvitationResponse>> {
    let uri = `/condominium/${idCondominium}/invitation`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateInvitationResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteInvitation
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID de invitación
  * @return The full HTTP response as Observable
  */
  public deleteInvitation(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/invitation/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method invitationDetail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The id de la invitación
  * @return The full HTTP response as Observable
  */
  public invitationDetail(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<InvitationDetailResponse>> {
    let uri = `/condominium/${idCondominium}/invitation/detail/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<InvitationDetailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelinvitation
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The ID del condominio
  * @param date2 The ID del condominio
  * @param idHouse The ID de la casa
  * @param idStatus The status de la invitación
  * @return The full HTTP response as Observable
  */
  public excelinvitation(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, idStatus: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/excelinvitation/${date1}/${date2}/${idHouse}/${idStatus}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method rule
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public rule(Authorization: string, idCondominium: number): Observable<HttpResponse<AllRuleResponse>> {
    let uri = `/condominium/${idCondominium}/rule`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllRuleResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createRule
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del contacto a registrar
  * @return The full HTTP response as Observable
  */
  public createRule(Authorization: string, idCondominium: number, body: CreateRuleRequest): Observable<HttpResponse<CreateUpdateRuleResponse>> {
    let uri = `/condominium/${idCondominium}/rule`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateRuleResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateRule
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reglamento a modificar
  * @return The full HTTP response as Observable
  */
  public updateRule(Authorization: string, idCondominium: number, body: UpdateRuleRequest): Observable<HttpResponse<CreateUpdateRuleResponse>> {
    let uri = `/condominium/${idCondominium}/rule`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateRuleResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteRule
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idRule The ID del reglamento
  * @return The full HTTP response as Observable
  */
  public deleteRule(Authorization: string, idCondominium: number, idRule: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/rule/${idRule}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method expense
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public expense(Authorization: string, idCondominium: number): Observable<HttpResponse<AllExpenseResponse>> {
    let uri = `/condominium/${idCondominium}/expense`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllExpenseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createExpense
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del gasto
  * @return The full HTTP response as Observable
  */
  public createExpense(Authorization: string, idCondominium: number, body: CreateExpenseRequest): Observable<HttpResponse<CreateUpdateExpenseResponse>> {
    let uri = `/condominium/${idCondominium}/expense`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateExpenseResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method UpdateExpense
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del gasto a modificar
  * @return The full HTTP response as Observable
  */
  public UpdateExpense(Authorization: string, idCondominium: number, body: UpdateExpenseRequest): Observable<HttpResponse<CreateUpdateExpenseResponse>> {
    let uri = `/condominium/${idCondominium}/expense`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateExpenseResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method DeleteExpense
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idExpense The ID del gasto
  * @return The full HTTP response as Observable
  */
  public DeleteExpense(Authorization: string, idCondominium: number, idExpense: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/expense/${idExpense}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method expenseUrlS3
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del gasto
  * @param op The opción, es el documento, el xml o el pdf
  * @return The full HTTP response as Observable
  */
  public expenseUrlS3(Authorization: string, idCondominium: number, id: number, op: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/expense/${id}/${op}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method detailExpense
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del gasto
  * @return The full HTTP response as Observable
  */
  public detailExpense(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<ExpenseDetailResponse>> {
    let uri = `/condominium/${idCondominium}/detailexpense/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExpenseDetailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method invoice
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param status The status de la factura
  * @return The full HTTP response as Observable
  */
  public invoice(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, status: number): Observable<HttpResponse<InvoicesResponse>> {
    let uri = `/condominium/${idCondominium}/invoice/${date1}/${date2}/${idHouse}/${status}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<InvoicesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method sendinvoice
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos para buscar la factura
  * @return The full HTTP response as Observable
  */
  public sendinvoice(Authorization: string, idCondominium: number, body: SendInvoiceRequest): Observable<HttpResponse<SendInvoiceResponse>> {
    let uri = `/condominium/${idCondominium}/sendinvoice`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<SendInvoiceResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method sendreceipt
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos del id de pago y el correo
  * @return The full HTTP response as Observable
  */
  public sendreceipt(Authorization: string, idCondominium: number, body: SendInvoiceRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/sendreceipt`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method cancelinvoice
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos para buscar la factura
  * @return The full HTTP response as Observable
  */
  public cancelinvoice(Authorization: string, idCondominium: number, body: CancelInvoiceRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/cancelinvoice`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method reportpayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param type The tipo de reporte, si es por fecha de pago = 1, o fecha de captura = 2
  * @return The full HTTP response as Observable
  */
  public reportpayment(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, type: number): Observable<HttpResponse<ReportPaymentsResponse>> {
    let uri = `/condominium/${idCondominium}/reportpayment/${date1}/${date2}/${idHouse}/${type}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ReportPaymentsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportpayment
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param type The tipo de reporte, si es por fecha de pago = 1, o fecha de captura = 2
  * @return The full HTTP response as Observable
  */
  public excelreportpayment(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, type: number): Observable<HttpResponse<ExcelReportPaymentResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportpayment/${date1}/${date2}/${idHouse}/${type}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelReportPaymentResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportdebtors
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param idConcept The ID del concepto
  * @param idConceptGroup The ID del grupo
  * @return The full HTTP response as Observable
  */
  public reportdebtors(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, idConcept: number, idConceptGroup: number): Observable<HttpResponse<ReportDebtorsResponse>> {
    let uri = `/condominium/${idCondominium}/reportdebtors/${date1}/${date2}/${idHouse}/${idConcept}/${idConceptGroup}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ReportDebtorsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportdebtors
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param idConcept The ID del concepto
  * @param idConceptGroup The ID del grupo
  * @return The full HTTP response as Observable
  */
  public excelreportdebtors(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, idConcept: number, idConceptGroup: number): Observable<HttpResponse<ExcelReportDebtorsResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportdebtors/${date1}/${date2}/${idHouse}/${idConcept}/${idConceptGroup}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelReportDebtorsResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportexpense
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public reportexpense(Authorization: string, idCondominium: number, date1: string, date2: string): Observable<HttpResponse<ReportExpensesResponse>> {
    let uri = `/condominium/${idCondominium}/reportexpense/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ReportExpensesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportexpense
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public excelreportexpense(Authorization: string, idCondominium: number, date1: string, date2: string): Observable<HttpResponse<ExcelReportExpenseResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportexpense/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelReportExpenseResponse>('get', uri, headers, params, null);
  }

  /**
  * Method pdfreportinvoicebyday
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public pdfreportinvoicebyday(Authorization: string, idCondominium: number, date1: string): Observable<HttpResponse<PDFReportInvoiceByDayResponse>> {
    let uri = `/condominium/${idCondominium}/pdfreportinvoicebyday/${date1}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PDFReportInvoiceByDayResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportinvoicebyday
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date The día del reporte
  * @return The full HTTP response as Observable
  */
  public excelreportinvoicebyday(Authorization: string, idCondominium: number, date: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportinvoicebyday/${date}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method pdfreportinvoicebymonth
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month The datos del filtrado
  * @param year The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public pdfreportinvoicebymonth(Authorization: string, idCondominium: number, month: number, year: number): Observable<HttpResponse<PDFReportInvoiceByMonthResponse>> {
    let uri = `/condominium/${idCondominium}/pdfreportinvoicebymonth/${month}/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PDFReportInvoiceByMonthResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelinvoice
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param status The status de la factura
  * @return The full HTTP response as Observable
  */
  public excelinvoice(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, status: number): Observable<HttpResponse<ExcelInvoiceResponse>> {
    let uri = `/condominium/${idCondominium}/excelinvoice/${date1}/${date2}/${idHouse}/${status}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelInvoiceResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportinvoicebymonth
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month The datos del filtrado
  * @param year The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public excelreportinvoicebymonth(Authorization: string, idCondominium: number, month: number, year: number): Observable<HttpResponse<ExcelReportInvoiceByMonthResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportinvoicebymonth/${month}/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelReportInvoiceByMonthResponse>('get', uri, headers, params, null);
  }

  /**
  * Method zipreportinvoicebymonth
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month The datos del filtrado
  * @param year The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public zipreportinvoicebymonth(Authorization: string, idCondominium: number, month: number, year: number): Observable<HttpResponse<ZipReportInvoiceByMonthResponse>> {
    let uri = `/condominium/${idCondominium}/zipreportinvoicebymonth/${month}/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ZipReportInvoiceByMonthResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportpaymentbyday
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date The día del reporte
  * @return The full HTTP response as Observable
  */
  public excelreportpaymentbyday(Authorization: string, idCondominium: number, date: string): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/excelpaymentbyday/${date}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportpaymentbymonth
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The año del reporte
  * @param month The mes del reporte
  * @return The full HTTP response as Observable
  */
  public excelreportpaymentbymonth(Authorization: string, idCondominium: number, year: number, month: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/excelpaymentbymonth/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method pdfreportpaymentbyday
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date The día del reporte
  * @return The full HTTP response as Observable
  */
  public pdfreportpaymentbyday(Authorization: string, idCondominium: number, date: string): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/pdfreportpaymentbyday/${date}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method pdfreportpaymentbymonth
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The año del reporte
  * @param month The mes del reporte
  * @return The full HTTP response as Observable
  */
  public pdfreportpaymentbymonth(Authorization: string, idCondominium: number, year: number, month: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/pdfreportpaymentbymonth/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelbalancereport
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month The datos del filtrado
  * @param year The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public excelbalancereport(Authorization: string, idCondominium: number, month: number, year: number): Observable<HttpResponse<ExcelBalanceReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelbalancereport/${month}/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelBalanceReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelpaymentshousetype
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month The datos del filtrado
  * @param year The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public excelpaymentshousetype(Authorization: string, idCondominium: number, month: number, year: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/excelpaymentshousetype/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelbalancebyaccount
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month The datos del filtrado
  * @param year The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public excelbalancebyaccount(Authorization: string, idCondominium: number, month: number, year: number): Observable<HttpResponse<ExcelBalanceReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelbalancebyaccount/${month}/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelBalanceReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method contpaqincomepolicy
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param policy The Número de poliza contable
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public contpaqincomepolicy(Authorization: string, idCondominium: number, policy: number, date1: string, date2: string): Observable<HttpResponse<ContpaqIncomePolicyResponse>> {
    let uri = `/condominium/${idCondominium}/contpaqincomepolicy/${policy}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ContpaqIncomePolicyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method contpaqincomegrouppolicy
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param policy The Número de poliza contable
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public contpaqincomegrouppolicy(Authorization: string, idCondominium: number, policy: number, date1: string, date2: string): Observable<HttpResponse<ContpaqIncomePolicyResponse>> {
    let uri = `/condominium/${idCondominium}/contpaqincomegrouppolicy/${policy}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ContpaqIncomePolicyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelcollectiontable
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The Año de los cargos
  * @param reportvariant The Variante del reporte 1 = Normal 2 = Con extraordinarios
  * @return The full HTTP response as Observable
  */
  public excelcollectiontable(Authorization: string, idCondominium: number, year: number, reportvariant: number): Observable<HttpResponse<ExcelCollectionTableResponse>> {
    let uri = `/condominium/${idCondominium}/excelcollectiontable/${year}/${reportvariant}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelCollectionTableResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelstatesale
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idConcept The concepto
  * @param date1 The fecha inicio
  * @param date2 The fecha fin
  * @return The full HTTP response as Observable
  */
  public excelstatesale(Authorization: string, idCondominium: number, idConcept: number, date1: number, date2: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/excelstatesale/${idConcept}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportcollectiontable
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The Año de los cargos
  * @return The full HTTP response as Observable
  */
  public reportcollectiontable(Authorization: string, idCondominium: number, year: number): Observable<HttpResponse<ReportCollectionTableResponse>> {
    let uri = `/condominium/${idCondominium}/reportcollectiontable/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ReportCollectionTableResponse>('get', uri, headers, params, null);
  }

  /**
  * Method pdfaccountstatement
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The Año de los cargos
  * @param idHouse The Identificador de la casa
  * @param language The lenguage del estado de cuenta es/en
  * @return The full HTTP response as Observable
  */
  public pdfaccountstatement(Authorization: string, idCondominium: number, year: number, idHouse: number, language: string): Observable<HttpResponse<PDFAccountStatement>> {
    let uri = `/condominium/${idCondominium}/pdfaccountstatement/${year}/${idHouse}/${language}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PDFAccountStatement>('get', uri, headers, params, null);
  }

  /**
  * Method pdfaccountstatementall
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The Año de los cargos
  * @param language The lenguage del estado de cuenta es/en
  * @return The full HTTP response as Observable
  */
  public pdfaccountstatementall(Authorization: string, idCondominium: number, year: number, language: string): Observable<HttpResponse<PDFAccountStatement>> {
    let uri = `/condominium/${idCondominium}/pdfaccountstatementall/${year}/${language}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<PDFAccountStatement>('get', uri, headers, params, null);
  }

  /**
  * Method sendaccountstatement
  * @param Authorization The access token.
  * @param idCondominium The ID del condominio
  * @param body The Datos para buscar la factura
  * @return The full HTTP response as Observable
  */
  public sendaccountstatement(Authorization: string, idCondominium: number, body: SendAccountStatementRequest): Observable<HttpResponse<SendAccountStatementResponse>> {
    let uri = `/condominium/${idCondominium}/sendaccountstatement`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<SendAccountStatementResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method reportestimateexcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The año
  * @param month The mes
  * @param idEstimate The mes
  * @return The full HTTP response as Observable
  */
  public reportestimateexcel(Authorization: string, idCondominium: number, year: number, month: number, idEstimate: number): Observable<HttpResponse<ExcelResponse>> {
    let uri = `/condominium/${idCondominium}/reportestimate/excel/${year}/${month}/${idEstimate}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ExcelResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportestimate
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The año
  * @param month The mes
  * @param idEstimate The estimación
  * @return The full HTTP response as Observable
  */
  public reportestimate(Authorization: string, idCondominium: number, year: number, month: number, idEstimate: number): Observable<HttpResponse<ReportEstimateResponse>> {
    let uri = `/condominium/${idCondominium}/reportestimate/${year}/${month}/${idEstimate}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ReportEstimateResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportbank
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idAccount The ID de cuenta bancaria
  * @param date1 The fecha inicio
  * @param date2 The fecha final
  * @return The full HTTP response as Observable
  */
  public excelreportbank(Authorization: string, idCondominium: number, idAccount: number, date1: string, date2: string): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportbank/${idAccount}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportbank
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idAccount The ID de cuenta bancaria
  * @param date1 The fecha inicio
  * @param date2 The fecha final
  * @return The full HTTP response as Observable
  */
  public reportbank(Authorization: string, idCondominium: number, idAccount: number, date1: string, date2: string): Observable<HttpResponse<AllReportBankResponse>> {
    let uri = `/condominium/${idCondominium}/reportbank/${idAccount}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllReportBankResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreporthousemovement
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public excelreporthousemovement(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreporthousemovement/${idHouse}/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method pdfreporthousemovement
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la unidad
  * @param date1 The Dato de filtrado
  * @param date2 The Dato de filtrado
  * @param type The Tipo de reporte que se desea obtener.1- General. 2- Por conceptos. 3- Por grupo.
  * @param idConcept The Id del concepto que se desea obtener
  * @param idGroup The Id del grupo que se desea obtener
  * @return The full HTTP response as Observable
  */
  public pdfreporthousemovement(Authorization: string, idCondominium: number, idHouse: number, date1: string, date2: string, type: number, idConcept: number, idGroup: number): Observable<HttpResponse<CommonPDFReportResponse>> {
    let uri = `/condominium/${idCondominium}/pdfreporthousemovement/${idHouse}/${date1}/${date2}/type/${type}/concept/${idConcept}/group/${idGroup}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonPDFReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelgetreporthousemovement
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la unidad
  * @param date1 The Datos del filtrado
  * @param date2 The Datos del filtrado
  * @param type The Tipo de reporte que se desea obtener.1- Por concepto. 2- Por grupo.
  * @param idConcept The Id del concepto que se desea obtener
  * @param idGroup The Id del grupo que se desea obtener
  * @return The full HTTP response as Observable
  */
  public excelgetreporthousemovement(Authorization: string, idCondominium: number, idHouse: number, date1: string, date2: string, type: number, idConcept: number, idGroup: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelgetreporthousemovement/${idHouse}/${date1}/${date2}/type/${type}/concept/${idConcept}/group/${idGroup}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportpaymentdetail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param type The Tipo de reporte que se desea obtener.1- Por fecha de pago, 2- Por fecha de captura
  * @return The full HTTP response as Observable
  */
  public excelreportpaymentdetail(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, type: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportpaymentdetail/${date1}/${date2}/${idHouse}/${type}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportpaymentdetailvidanta
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param type The Tipo de reporte que se desea obtener.1- Por fecha de pago, 2- Por fecha de captura
  * @return The full HTTP response as Observable
  */
  public excelreportpaymentdetailvidanta(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, type: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportpaymentdetailvidanta/${date1}/${date2}/${idHouse}/${type}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportpaymentdetailvidantageneral
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param type The Tipo de reporte que se desea obtener.1- Por fecha de pago, 2- Por fecha de captura
  * @return The full HTTP response as Observable
  */
  public excelreportpaymentdetailvidantageneral(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, type: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportpaymentdetailvidantageneral/${date1}/${date2}/${idHouse}/${type}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelreportpaymentwithcharges
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @param type The Tipo de reporte que se desea obtener.1- Por fecha de pago, 2- Por fecha de captura
  * @return The full HTTP response as Observable
  */
  public excelreportpaymentwithcharges(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number, type: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportpaymentwithcharges/${date1}/${date2}/${idHouse}/${type}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelhouseandresidents
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public excelhouseandresidents(Authorization: string, idCondominium: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelhouseandresidents`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelservicechargehouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idServiceCharge The datos del filtrado
  * @return The full HTTP response as Observable
  */
  public excelservicechargehouse(Authorization: string, idCondominium: number, idServiceCharge: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelservicechargehouse/${idServiceCharge}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelchargehouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del recargo a modificar
  * @return The full HTTP response as Observable
  */
  public excelchargehouse(Authorization: string, idCondominium: number, body: ExcelChargeHouseRequest): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelchargehouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method reportchargehouse
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del recargo a modificar
  * @return The full HTTP response as Observable
  */
  public reportchargehouse(Authorization: string, idCondominium: number, body: ExcelChargeHouseRequest): Observable<HttpResponse<AllReportChargeHouseResponse>> {
    let uri = `/condominium/${idCondominium}/reportchargehouse`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllReportChargeHouseResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method sendpaymentreminder
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public sendpaymentreminder(Authorization: string, idCondominium: number): Observable<HttpResponse<GenericResponse>> {
    let uri = `/condominium/${idCondominium}/sendpaymentreminder`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<GenericResponse>('get', uri, headers, params, null);
  }

  /**
  * Method sendaccountstatementcondominium
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public sendaccountstatementcondominium(Authorization: string, idCondominium: number): Observable<HttpResponse<GenericResponse>> {
    let uri = `/condominium/${idCondominium}/sendaccountstatementcondominium`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<GenericResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportmix
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param year The Año del reporte
  * @return The full HTTP response as Observable
  */
  public reportmix(Authorization: string, idCondominium: number, date1: string, date2: string, year: number): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportmix/${date1}/${date2}/${year}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method contpaqdiaryprovisioning
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param policy The Número de poliza contable
  * @param year The ano
  * @param month The mes
  * @return The full HTTP response as Observable
  */
  public contpaqdiaryprovisioning(Authorization: string, idCondominium: number, policy: number, year: number, month: number): Observable<HttpResponse<ContpaqIncomePolicyResponse>> {
    let uri = `/condominium/${idCondominium}/contpaqdiaryprovisioning/${policy}/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ContpaqIncomePolicyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method contpaqdiaryprovisioningbyconcept
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param policy The Número de poliza contable
  * @param year The ano
  * @param month The mes
  * @param idConcept The idConcept
  * @return The full HTTP response as Observable
  */
  public contpaqdiaryprovisioningbyconcept(Authorization: string, idCondominium: number, policy: number, year: number, month: number, idConcept: number): Observable<HttpResponse<ContpaqIncomePolicyResponse>> {
    let uri = `/condominium/${idCondominium}/contpaqdiaryprovisioningbyconcept/${policy}/${year}/${month}/${idConcept}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ContpaqIncomePolicyResponse>('get', uri, headers, params, null);
  }

  /**
  * Method contpaqdiaryprovisioningbydiscount
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param policy The Número de poliza contable
  * @param year The ano
  * @param month The mes
  * @return The full HTTP response as Observable
  */
  public contpaqdiaryprovisioningbydiscount(Authorization: string, idCondominium: number, policy: number, year: number, month: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/contpaqdiaryprovisioningbydiscount/${policy}/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportExcelIncidences
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The Primer dato de filtrado
  * @param date2 The Segundo dato de filtrado
  * @return The full HTTP response as Observable
  */
  public reportExcelIncidences(Authorization: string, idCondominium: number, date1: string, date2: string): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportincidences/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportInvitation
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The Primer dato de filtrado
  * @param date2 The Segundo dato de filtrado
  * @return The full HTTP response as Observable
  */
  public reportInvitation(Authorization: string, idCondominium: number, date1: string, date2: string): Observable<HttpResponse<CommonExcelReportResponse>> {
    let uri = `/condominium/${idCondominium}/excelreportinvitation/${date1}/${date2}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CommonExcelReportResponse>('get', uri, headers, params, null);
  }

  /**
  * Method excelIncome
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The año
  * @param month The mes
  * @return The full HTTP response as Observable
  */
  public excelIncome(Authorization: string, idCondominium: number, year: number, month: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/excelincome/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method reportIncome
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The año
  * @param month The mes
  * @return The full HTTP response as Observable
  */
  public reportIncome(Authorization: string, idCondominium: number, year: number, month: number): Observable<HttpResponse<AllReportIncomeResponse>> {
    let uri = `/condominium/${idCondominium}/reportincome/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllReportIncomeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method chargerecharges
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param date1 The datos del filtrado
  * @param date2 The datos del filtrado
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public chargerecharges(Authorization: string, idCondominium: number, date1: string, date2: string, idHouse: number): Observable<HttpResponse<ChargeRechargesResponse>> {
    let uri = `/condominium/${idCondominium}/chargerecharges/${date1}/${date2}/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<ChargeRechargesResponse>('get', uri, headers, params, null);
  }

  /**
  * Method addRecharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del recargo a agregar
  * @return The full HTTP response as Observable
  */
  public addRecharge(Authorization: string, idCondominium: number, body: CreateRechargeRequest): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/recharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateRecharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del recargo a modificar
  * @return The full HTTP response as Observable
  */
  public updateRecharge(Authorization: string, idCondominium: number, body: UpdateRechargeRequest): Observable<HttpResponse<UpdateRechargeResponse>> {
    let uri = `/condominium/${idCondominium}/recharge`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UpdateRechargeResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteRecharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del Condomininio
  * @param idRecharge The ID del Cargo que es recargo en la tabla de cargos
  * @param isCheckReverseMovement The Indica si se debe reversar el movimiento
  * @param dateReverseMovement The Fecha de reversa del movimiento
  * @return The full HTTP response as Observable
  */
  public deleteRecharge(Authorization: string, idCondominium: number, idRecharge: number, isCheckReverseMovement: boolean, dateReverseMovement: string): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/recharge/${idRecharge}/${isCheckReverseMovement}/${dateReverseMovement}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method suggestiondates
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param month The datos del filtrado
  * @param year The datos del filtrado
  * @param idCharge The ID de la casa
  * @return The full HTTP response as Observable
  */
  public suggestiondates(Authorization: string, idCondominium: number, month: number, year: number, idCharge: number): Observable<HttpResponse<DataStringResponse>> {
    let uri = `/condominium/${idCondominium}/recharge/suggestiondate/${month}/${year}/${idCharge}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataStringResponse>('get', uri, headers, params, null);
  }

  /**
  * Method rechargesbycharge
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idCharge The ID del cargo
  * @return The full HTTP response as Observable
  */
  public rechargesbycharge(Authorization: string, idCondominium: number, idCharge: number): Observable<HttpResponse<AllRechargesByChargeResponse>> {
    let uri = `/condominium/${idCondominium}/rechargesbycharge/${idCharge}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllRechargesByChargeResponse>('get', uri, headers, params, null);
  }

  /**
  * Method accesscard
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public accesscard(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<AccessCardResponse>> {
    let uri = `/condominium/${idCondominium}/accesscard/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AccessCardResponse>('get', uri, headers, params, null);
  }

  /**
  * Method accesscarddoor
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idAccessPanel The ID del panel
  * @return The full HTTP response as Observable
  */
  public accesscarddoor(Authorization: string, idCondominium: number, idAccessPanel: number): Observable<HttpResponse<AccessCardDoorResponse>> {
    let uri = `/condominium/${idCondominium}/accesscarddoor/${idAccessPanel}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AccessCardDoorResponse>('get', uri, headers, params, null);
  }

  /**
  * Method addcard
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del la tarjeta de acceso
  * @return The full HTTP response as Observable
  */
  public addcard(Authorization: string, idCondominium: number, body: CreateAccessCardRequest): Observable<HttpResponse<CreateUpdateAccessCardResponse>> {
    let uri = `/condominium/${idCondominium}/accesscard`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateAccessCardResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editcard
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del la tarjeta de acceso
  * @return The full HTTP response as Observable
  */
  public editcard(Authorization: string, idCondominium: number, body: UpdateAccessCardRequest): Observable<HttpResponse<CreateUpdateAccessCardResponse>> {
    let uri = `/condominium/${idCondominium}/accesscard`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateAccessCardResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deletecard
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del Condomininio
  * @param id The ID de la tarjeta
  * @return The full HTTP response as Observable
  */
  public deletecard(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/accesscarddelete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method accesscardExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param incluidePictures The Indica si se incluyen las fotos de las tarjetas
  * @return The full HTTP response as Observable
  */
  public accesscardExcel(Authorization: string, idCondominium: number, incluidePictures: boolean): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/accesscardexcel/${incluidePictures}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method activateOrInactivateAccessCard
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @param method The Método a utilizar (activar o desactivar)
  * @return The full HTTP response as Observable
  */
  public activateOrInactivateAccessCard(Authorization: string, idCondominium: number, idHouse: number, method: string): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/accesscard/activeorinactive/${idHouse}/${method}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('put', uri, headers, params, null);
  }

  /**
  * Method fiscaldata
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idHouse The ID de la casa
  * @return The full HTTP response as Observable
  */
  public fiscaldata(Authorization: string, idCondominium: number, idHouse: number): Observable<HttpResponse<FiscalDataResponse>> {
    let uri = `/condominium/${idCondominium}/fiscaldata/${idHouse}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<FiscalDataResponse>('get', uri, headers, params, null);
  }

  /**
  * Method addfiscaldata
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos fiscales
  * @return The full HTTP response as Observable
  */
  public addfiscaldata(Authorization: string, idCondominium: number, body: CreateFiscalDataRequest): Observable<HttpResponse<CreateUpdateFiscalDataResponse>> {
    let uri = `/condominium/${idCondominium}/fiscaldata`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateFiscalDataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method editfiscaldata
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del la tarjeta de acceso
  * @return The full HTTP response as Observable
  */
  public editfiscaldata(Authorization: string, idCondominium: number, body: UpdateFiscalDataRequest): Observable<HttpResponse<CreateUpdateFiscalDataResponse>> {
    let uri = `/condominium/${idCondominium}/fiscaldata`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<CreateUpdateFiscalDataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deletefiscaldata
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del Condomininio
  * @param idHouse The ID de la casa
  * @param id The ID del dato fiscal
  * @return The full HTTP response as Observable
  */
  public deletefiscaldata(Authorization: string, idCondominium: number, idHouse: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/fiscaldata/${idHouse}/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method excelFiscaldata
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public excelFiscaldata(Authorization: string, idCondominium: number): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/fiscaldataexcel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('get', uri, headers, params, null);
  }

  /**
  * Method getActionModules
  * @param Authorization The Frakcio Admin
  * @return The full HTTP response as Observable
  */
  public getActionModules(Authorization: string): Observable<HttpResponse<AllModuleResponse>> {
    let uri = `/modules`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllModuleResponse>('get', uri, headers, params, null);
  }

  /**
  * Method getRol
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param idRol The ID del perfil
  * @return The full HTTP response as Observable
  */
  public getRol(Authorization: string, idCondominium: number, idRol: number): Observable<HttpResponse<AllRolInfoResponse>> {
    let uri = `/condominium/${idCondominium}/rol/${idRol}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllRolInfoResponse>('get', uri, headers, params, null);
  }

  /**
  * Method rol
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @return The full HTTP response as Observable
  */
  public rol(Authorization: string, idCondominium: number): Observable<HttpResponse<AllRolResponse>> {
    let uri = `/condominium/${idCondominium}/rol`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllRolResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createRol
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de login
  * @return The full HTTP response as Observable
  */
  public createRol(Authorization: string, idCondominium: number, body: CreateRolDataRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/rol`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method updateRol
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de login
  * @return The full HTTP response as Observable
  */
  public updateRol(Authorization: string, idCondominium: number, body: UpdateRolDataRequest): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/rol`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('put', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method deleteRol
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The Nombre del perfil
  * @return The full HTTP response as Observable
  */
  public deleteRol(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<DataResponse>> {
    let uri = `/condominium/${idCondominium}/rol/delete/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<DataResponse>('delete', uri, headers, params, null);
  }

  /**
  * Method visitorReport
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de busqueda
  * @return The full HTTP response as Observable
  */
  public visitorReport(Authorization: string, idCondominium: number, body: VisitorReportRequest): Observable<HttpResponse<AllVisitorReportResponse>> {
    let uri = `/condominium/${idCondominium}/access/report`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllVisitorReportResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method visitorReportExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos de busqueda
  * @return The full HTTP response as Observable
  */
  public visitorReportExcel(Authorization: string, idCondominium: number, body: VisitorReportRequest): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/access/report/excel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method visitorReportDetail
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param id The ID del registro
  * @return The full HTTP response as Observable
  */
  public visitorReportDetail(Authorization: string, idCondominium: number, id: number): Observable<HttpResponse<AllVisitorDetailResponse>> {
    let uri = `/condominium/${idCondominium}/access/detail/${id}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllVisitorDetailResponse>('get', uri, headers, params, null);
  }

  /**
  * Method createEventReport
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reporte de eventos
  * @return The full HTTP response as Observable
  */
  public createEventReport(Authorization: string, idCondominium: number, body: CreateEventReportRequest): Observable<HttpResponse<EventReportResponse>> {
    let uri = `/condominium/${idCondominium}/eventreport`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<EventReportResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method eventReport
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reporte de eventos
  * @return The full HTTP response as Observable
  */
  public eventReport(Authorization: string, idCondominium: number, body: SearchEventReportRequest): Observable<HttpResponse<AllEventReportResponse>> {
    let uri = `/condominium/${idCondominium}/eventreport/search`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<AllEventReportResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method eventReportExcel
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param body The Datos del reporte de eventos
  * @return The full HTTP response as Observable
  */
  public eventReportExcel(Authorization: string, idCondominium: number, body: SearchEventReportRequest): Observable<HttpResponse<UrlResponse>> {
    let uri = `/condominium/${idCondominium}/eventreport/excel`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<UrlResponse>('post', uri, headers, params, JSON.stringify(body));
  }

  /**
  * Method chargeFees
  * @param Authorization The Frakcio Admin
  * @param idCondominium The ID del condominio
  * @param year The Año de la cuota
  * @param month The Mes de la cuota
  * @return The full HTTP response as Observable
  */
  public chargeFees(Authorization: string, idCondominium: number, year: number, month: number): Observable<HttpResponse<NoDataResponse>> {
    let uri = `/condominium/${idCondominium}/chargebycondominium/${year}/${month}`;
    let headers = new HttpHeaders();
    let params = new HttpParams();
    if (Authorization) {
      headers = headers.set('Authorization', Authorization + '');
    }
    return this.sendRequest<NoDataResponse>('get', uri, headers, params, null);
  }

  private sendRequest<T>(method: string, uri: string, headers: HttpHeaders, params: HttpParams, body: any): Observable<HttpResponse<T>> {
    if (method === 'get') {
      return this.http.get<T>(this.domain + uri, { headers: headers.set('Accept', 'application/json'), params: params, observe: 'response' });
    } else if (method === 'put') {
      return this.http.put<T>(this.domain + uri, body, { headers: headers.set('Content-Type', 'application/json'), params: params, observe: 'response' });
    } else if (method === 'post') {
      return this.http.post<T>(this.domain + uri, body, { headers: headers.set('Content-Type', 'application/json'), params: params, observe: 'response' });
    } else if (method === 'delete') {
      return this.http.delete<T>(this.domain + uri, { headers: headers, params: params, observe: 'response' });
    } else {
      console.error('Unsupported request: ' + method);
      return Observable.throw('Unsupported request: ' + method);
    }
  }
}
